import React from 'react'
import { useStore } from '@nanostores/react'

import { activeTile, hoverTile } from './store'

const isInRange = (num, min, max) => num >= min && num <= max

export default function Radar() {
  const active = useStore(activeTile)

  function onClick(index) {
    activeTile.set(index)
  }

  function onMouseEnter(index) {
    hoverTile.set(index)
  }

  return (
    <svg
      version="1.1"
      id="chart"
      x="0px"
      y="0px"
      viewBox="0 0 490 490"
      xmlSpace="preserve"
    >
      <g id="industry-activity">
        <g>
          <path
            id="path-26"
            d="M244.8,244.9L207.8,96
  c12.6-3.1,24.1-4.6,37.1-4.6V244.9z"
            data-active={active === 26}
            onClick={() => onClick(26)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(26)}
          />
          <path
            className="filler"
            d="M245.3,249L207.2,95.7l0.5-0.1c12.7-3.2,24.2-4.6,37.2-4.6h0.5V249z M208.4,96.4l36,144.5V92
  C231.8,92,220.6,93.4,208.4,96.4z"
          />
        </g>
        <g>
          <path
            id="path-25"
            d="M244.8,244.9l-71.9-135.5
			c11.4-6.1,22.3-10.3,34.9-13.4L244.8,244.9L244.8,244.9z"
            data-active={active === 25}
            onClick={() => onClick(25)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(25)}
          />
          <path
            className="filler"
            d="M245.3,246.9l-0.9-1.8l-72.2-135.9l0.4-0.2c11.5-6.1,22.3-10.3,35-13.5l0.5-0.1l37.2,149.5V246.9z
			 M173.6,109.6l69.8,131.5l-36-144.5C195.2,99.7,184.7,103.7,173.6,109.6z"
          />
        </g>
        <g>
          <path
            id="path-24"
            d="M244.8,244.9l-102.5-114
			c9.6-8.7,19.2-15.4,30.6-21.5L244.8,244.9L244.8,244.9z"
            data-active={active === 24}
            onClick={() => onClick(24)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(24)}
          />
          <path
            className="filler"
            d="M245.3,246.2l-0.9-1L141.6,130.9l0.4-0.3c9.7-8.8,19.2-15.4,30.7-21.5l0.4-0.2l0.2,0.4l72,135.6
			V246.2z M143,130.9l99.5,110.7l-69.8-131.5C161.6,116.1,152.4,122.5,143,130.9z"
          />
        </g>
        <g>
          <path
            id="path-23"
            d="M244.8,244.9l-127-85.8
			c7.2-10.8,14.9-19.6,24.5-28.2L244.8,244.9z"
            data-active={active === 23}
            onClick={() => onClick(23)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(23)}
          />
          <path
            className="filler"
            d="M247.9,247.6l-130.8-88.4l0.3-0.4c7.3-10.8,14.9-19.6,24.6-28.3l0.4-0.3l0.3,0.4L247.9,247.6z
			 M118.5,159l123.2,83.3l-99.5-110.6C132.9,140.1,125.6,148.6,118.5,159z"
          />
        </g>
        <g id="_x32_3">
          <path
            d="M142.8,164.8c0-1.4-0.1-2.5-0.2-3.3c-0.1-0.8-0.2-1.6-0.5-2.3c-0.2-0.7-0.6-1.3-1.1-1.7
			c-0.5-0.4-1-0.6-1.5-0.6c-0.5,0-0.9,0.3-1.4,0.8c-0.4,0.5-0.6,1-0.5,1.6c0.1,0.5,0.4,1,0.9,1.5l-1.1,1.4c-0.9-0.8-1.4-1.7-1.5-2.7
			s0.3-1.9,1-2.7c0.8-0.9,1.6-1.4,2.5-1.5c0.9-0.1,1.8,0.2,2.7,0.9c0.6,0.5,1.1,1.1,1.4,1.9c0.3,0.8,0.5,1.6,0.6,2.3
			c0.1,0.8,0.2,1.8,0.2,2.9l0,1l3.3-4l1.2,1l-5,6.2l-1.1-0.9L142.8,164.8L142.8,164.8z"
          />
          <path
            d="M142.6,151.4c0.1-0.9,0.5-1.8,1.3-2.6c0.5-0.6,1.1-0.9,1.7-1.2c0.6-0.2,1.1-0.3,1.7-0.1
			c0.5,0.1,1,0.4,1.5,0.8c0.5,0.5,0.8,1,0.9,1.6c0.1,0.6,0,1.1-0.2,1.6l0,0c0.6-0.3,1.2-0.5,1.8-0.4c0.6,0.1,1.2,0.4,1.8,1
			c0.5,0.5,0.8,0.9,0.9,1.5c0.2,0.6,0.1,1.2,0,1.8c-0.2,0.6-0.6,1.2-1.1,1.8c-0.8,0.9-1.7,1.4-2.7,1.5c-1,0.1-1.9-0.2-2.7-0.9
			l1.2-1.3c0.5,0.4,0.9,0.5,1.5,0.5c0.6,0,1.1-0.3,1.5-0.8c0.5-0.5,0.7-1,0.7-1.5c0-0.5-0.2-1-0.6-1.4c-0.6-0.5-1.1-0.7-1.7-0.6
			c-0.6,0.1-1.2,0.6-1.9,1.3l-0.3,0.3l-1.1-1.1l0.3-0.3c0.6-0.6,1-1.2,1.1-1.8c0.1-0.5-0.1-1-0.5-1.4c-0.4-0.4-0.8-0.5-1.3-0.5
			c-0.5,0-0.9,0.3-1.3,0.7c-0.4,0.4-0.6,0.9-0.6,1.4c0,0.5,0.1,0.9,0.4,1.2l-1.3,1.3C142.8,153.2,142.5,152.4,142.6,151.4
			L142.6,151.4z"
          />
        </g>
        <g id="_x32_4">
          <path
            d="M163.8,143.6c0.3-1.4,0.5-2.5,0.6-3.3s0.2-1.6,0.1-2.4c-0.1-0.7-0.3-1.4-0.7-1.9
			c-0.4-0.5-0.8-0.8-1.3-0.9c-0.5-0.1-1,0-1.5,0.5c-0.5,0.4-0.8,0.9-0.8,1.4s0.2,1.1,0.6,1.7l-1.4,1.1c-0.7-1-1-2-0.8-3
			c0.2-1,0.7-1.8,1.6-2.5c0.9-0.7,1.9-1,2.8-0.9c0.9,0.1,1.7,0.6,2.4,1.5c0.5,0.6,0.8,1.3,0.9,2.2c0.1,0.8,0.1,1.6,0.1,2.4
			c-0.1,0.8-0.2,1.8-0.5,2.9l-0.2,1l4.1-3.2l0.9,1.2l-6.3,4.9l-0.8-1.1L163.8,143.6L163.8,143.6z"
          />
          <path
            d="M170.3,138.7l-0.8-1.2l0.3-9.6l1.9-1.2l4.2,6.4l1.3-0.8l0.9,1.4l-1.3,0.8l1.4,2.1l-1.5,1l-1.4-2.1
			L170.3,138.7L170.3,138.7z M171.3,129.2l-0.1,7l3.2-2.1L171.3,129.2L171.3,129.2z"
          />
        </g>
        <g id="_x32_5">
          <path
            d="M191.2,126.8c0.6-1.2,1.1-2.3,1.4-3c0.3-0.8,0.6-1.5,0.7-2.3c0.1-0.7,0.1-1.4-0.2-2
			c-0.3-0.6-0.6-1-1-1.2c-0.4-0.2-1-0.2-1.6,0.1c-0.6,0.3-1,0.6-1.1,1.2c-0.2,0.5-0.1,1.1,0.1,1.7l-1.7,0.7
			c-0.5-1.2-0.5-2.2-0.1-3.1s1.1-1.6,2.1-2c1.1-0.5,2.1-0.5,3-0.2c0.9,0.3,1.5,1,2,2c0.3,0.7,0.4,1.5,0.4,2.3
			c-0.1,0.8-0.3,1.6-0.5,2.4c-0.3,0.7-0.7,1.6-1.1,2.7l-0.4,0.9l4.8-2.1l0.6,1.4l-7.3,3.2l-0.5-1.3L191.2,126.8L191.2,126.8z"
          />
          <path
            d="M203.7,113.6l-5.2,1.8l1.1,3.1c0.1-0.4,0.4-0.7,0.7-1.1c0.4-0.3,0.8-0.6,1.3-0.8
			c0.9-0.3,1.6-0.4,2.3-0.2c0.7,0.2,1.2,0.5,1.7,1c0.4,0.5,0.7,1,1,1.7c0.3,0.8,0.4,1.5,0.3,2.2c-0.1,0.7-0.4,1.3-0.8,1.9
			c-0.5,0.5-1.1,1-2,1.2c-1.1,0.4-2.1,0.4-3,0.1c-0.9-0.3-1.5-0.9-2-1.8l1.7-0.6c0.3,0.5,0.7,0.7,1.2,0.9c0.5,0.2,1,0.1,1.6-0.1
			c0.7-0.3,1.2-0.7,1.4-1.2c0.2-0.6,0.2-1.2-0.1-2c-0.3-0.7-0.6-1.3-1.1-1.5c-0.5-0.3-1.1-0.3-1.8,0c-0.5,0.2-0.9,0.5-1.2,0.8
			c-0.3,0.4-0.4,0.8-0.4,1.3l-1.7,0.6l-2.2-6.5l6.8-2.3L203.7,113.6L203.7,113.6z"
          />
        </g>
        <g id="_x32_6">
          <path
            d="M220.6,117.4c0.9-1.1,1.6-1.9,2.1-2.6c0.5-0.7,0.9-1.4,1.2-2.1c0.3-0.7,0.4-1.4,0.3-2
			c-0.1-0.7-0.4-1.1-0.7-1.4c-0.4-0.3-0.9-0.4-1.5-0.3c-0.6,0.1-1.1,0.4-1.4,0.9c-0.3,0.5-0.4,1-0.3,1.7l-1.8,0.3
			c-0.2-1.2,0-2.2,0.6-3c0.6-0.8,1.4-1.2,2.5-1.4c1.2-0.2,2.1,0,2.9,0.5c0.8,0.5,1.2,1.3,1.4,2.4c0.1,0.8,0.1,1.6-0.2,2.3
			c-0.3,0.8-0.6,1.5-1.1,2.2s-1,1.4-1.7,2.3l-0.6,0.8l5.1-0.9l0.3,1.5l-7.9,1.3l-0.2-1.3L220.6,117.4L220.6,117.4z"
          />
          <path
            d="M234,107.8c-0.3-0.2-0.8-0.3-1.4-0.3c-0.9,0.1-1.5,0.5-1.8,1.2c-0.4,0.7-0.5,1.8-0.4,3.3
			c0.2-0.5,0.6-0.9,1.1-1.2c0.5-0.3,1.1-0.5,1.7-0.6c0.7-0.1,1.4,0,1.9,0.3c0.6,0.3,1,0.7,1.4,1.2c0.4,0.6,0.6,1.2,0.6,2.1
			c0.1,0.8,0,1.5-0.3,2.1c-0.2,0.6-0.6,1.1-1.2,1.5c-0.6,0.4-1.3,0.6-2.1,0.7c-1.1,0.1-2-0.1-2.7-0.5c-0.7-0.4-1.2-1.1-1.5-2
			c-0.3-0.9-0.6-2-0.7-3.3c-0.4-4,0.9-6.1,3.7-6.4c1.1-0.1,2,0.1,2.7,0.7s1.1,1.2,1.3,2.1l-1.7,0.2C234.6,108.4,234.3,108,234,107.8
			L234,107.8z M231.4,112.6c-0.4,0.4-0.6,1-0.5,1.8c0.1,0.7,0.3,1.3,0.8,1.7c0.5,0.4,1.1,0.6,1.9,0.5c0.7-0.1,1.2-0.3,1.6-0.8
			c0.4-0.5,0.5-1,0.4-1.8c-0.1-0.7-0.3-1.3-0.7-1.7c-0.4-0.4-1-0.6-1.8-0.5C232.3,111.9,231.8,112.2,231.4,112.6L231.4,112.6z"
          />
        </g>
        <path
          className="spacer"
          d="M246.8,248.7l-131.8-89l1.1-1.7c7.4-10.9,15-19.7,24.8-28.6c9.8-8.8,19.3-15.5,31-21.7
		c11.7-6.2,22.6-10.4,35.3-13.6l0,0c12.8-3.2,24.4-4.6,37.6-4.6h2V248.7z M120.6,158.6l122.2,82.6V93.5c-12,0.1-22.8,1.5-34.6,4.5
		l0,0c-12.4,3.1-23.1,7.2-34.4,13.2c-11.4,6.1-20.7,12.6-30.2,21.2C134.6,140.6,127.4,148.7,120.6,158.6z"
        />
        <g id="icon-industry-activity">
          <path
            d="M159.4,82h-23V62.9h7.4v5.6l3.2,2.2v-3.6l5.2,3.6v-3.6l7.2,5V82z M138.5,80h19v-6.9l-3.2-2.2v3.6
			l-5.2-3.6v3.6l-7.2-5v-4.7h-3.4V80z"
          />
          <rect x="142" y="76" width="2" height="5" />
        </g>
        <g className="label" data-active={isInRange(active, 23, 26)}>
          <path d="M119.1,128.7l7.8,7.1l-1.4,1.6l-7.8-7.1L119.1,128.7z" />
          <path
            d="M127.7,124.2c0.9,0,1.7,0.4,2.5,1.2l3.5,3.5l-1.5,1.5l-3.3-3.3c-0.5-0.5-1-0.7-1.4-0.7
			c-0.5,0-0.9,0.2-1.3,0.6c-0.4,0.4-0.6,0.9-0.6,1.4c0,0.5,0.3,1,0.7,1.4l3.3,3.3l-1.5,1.5l-5.9-5.9l1.5-1.5l0.7,0.7
			c-0.1-0.5,0-0.9,0.2-1.4s0.4-0.9,0.8-1.2C126,124.5,126.8,124.2,127.7,124.2z"
          />
          <path
            d="M130.6,122.9c-0.2-0.7-0.2-1.4,0-2.1c0.2-0.7,0.6-1.2,1.1-1.7c0.4-0.4,0.9-0.6,1.4-0.8
			c0.5-0.2,1-0.2,1.5-0.1l-2.6-3l1.6-1.4l7.5,8.4l-1.6,1.4l-0.8-0.9c0.1,0.5,0,1-0.2,1.5c-0.2,0.5-0.5,1-1,1.4
			c-0.5,0.5-1.1,0.8-1.8,0.9c-0.7,0.1-1.4,0-2.1-0.2c-0.7-0.3-1.3-0.7-1.9-1.4C131.2,124.3,130.8,123.6,130.6,122.9z M135.6,119.7
			c-0.4-0.1-0.8-0.2-1.2-0.1c-0.4,0.1-0.7,0.3-1,0.5c-0.3,0.3-0.5,0.6-0.6,0.9c-0.1,0.4-0.1,0.8,0,1.2c0.1,0.4,0.3,0.8,0.6,1.2
			c0.3,0.4,0.7,0.6,1.1,0.8c0.4,0.1,0.8,0.2,1.2,0.1c0.4-0.1,0.7-0.2,1-0.5c0.3-0.3,0.5-0.6,0.6-1c0.1-0.4,0.1-0.8,0-1.2
			c-0.1-0.4-0.3-0.8-0.7-1.2C136.3,120.1,136,119.9,135.6,119.7z"
          />
          <path
            d="M143.4,109.6l5.2,6.6l-1.7,1.3l-0.7-0.8c0,0.5-0.1,0.9-0.3,1.3c-0.2,0.4-0.5,0.8-0.9,1.1
			c-0.5,0.4-1.1,0.7-1.6,0.8c-0.6,0.1-1.1,0-1.7-0.2c-0.6-0.2-1.1-0.7-1.5-1.2l-3-3.9l1.7-1.3l2.9,3.6c0.4,0.5,0.9,0.8,1.3,0.9
			c0.5,0.1,1-0.1,1.4-0.4c0.5-0.4,0.7-0.8,0.7-1.3c0-0.5-0.1-1-0.6-1.5l-2.9-3.6L143.4,109.6z"
          />
          <path
            d="M151.1,114.2c-0.6,0.1-1.1,0.1-1.6-0.1c-0.5-0.2-0.9-0.4-1.2-0.9l1.7-1.2c0.2,0.2,0.5,0.4,0.9,0.4
			c0.3,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.6-0.7c0.1-0.3,0.1-0.5-0.1-0.7c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.8,0.2-1.3,0.4
			c-0.6,0.2-1.1,0.4-1.5,0.5c-0.4,0.1-0.8,0.1-1.3,0c-0.4-0.1-0.8-0.4-1.1-0.9c-0.3-0.4-0.4-0.8-0.4-1.3c0-0.5,0.1-0.9,0.4-1.4
			c0.3-0.5,0.7-0.9,1.2-1.3c0.8-0.6,1.6-0.8,2.4-0.8c0.8,0.1,1.4,0.4,2,1.1l-1.7,1.2c-0.2-0.3-0.5-0.4-0.8-0.4c-0.3,0-0.6,0.1-1,0.3
			c-0.3,0.2-0.5,0.4-0.6,0.7c-0.1,0.2-0.1,0.5,0.1,0.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.8-0.2,1.3-0.4c0.6-0.2,1.1-0.4,1.5-0.5
			c0.4-0.1,0.8-0.1,1.3,0c0.4,0.1,0.8,0.4,1.1,0.8c0.3,0.4,0.4,0.8,0.4,1.3c0,0.5-0.1,0.9-0.4,1.4c-0.3,0.5-0.7,0.9-1.2,1.3
			C152.2,113.8,151.6,114.1,151.1,114.2z"
          />
          <path
            d="M155.1,103.7l2.2,3.4c0.2,0.2,0.3,0.4,0.5,0.4c0.2,0,0.4,0,0.7-0.2l0.8-0.5l1,1.5l-1.1,0.7
			c-1.5,1-2.7,0.7-3.7-0.7l-2.2-3.4l-0.8,0.5l-0.9-1.5l0.8-0.5l-1.1-1.7l1.8-1.2l1.1,1.7l1.6-1l0.9,1.5L155.1,103.7z"
          />
          <path
            d="M160,99c0.2-0.4,0.6-0.8,1.1-1.1l1.1,1.9l-0.5,0.3c-0.6,0.3-0.9,0.7-1.1,1.2c-0.1,0.4,0,1,0.4,1.7
			l2.1,3.6l-1.8,1.1l-4.3-7.2l1.8-1.1l0.7,1.1C159.6,99.9,159.7,99.4,160,99z"
          />
          <path d="M169.6,93.4l1.2,13.3l-2,1.1l-0.4-4.5l-6.8-5.6l2.1-1.1l4.7,4.1l-0.8-6.2L169.6,93.4z" />
          <path
            d="M174.7,93c0-0.7,0.3-1.4,0.7-1.9c0.4-0.6,0.9-1,1.6-1.3c0.6-0.2,1.1-0.4,1.7-0.3s1,0.2,1.4,0.4
			l-0.5-1.1l2-0.9l3.4,7.7l-2,0.9l-0.5-1.1c-0.1,0.5-0.3,0.9-0.6,1.3c-0.3,0.4-0.8,0.8-1.4,1c-0.6,0.3-1.3,0.4-2,0.3
			c-0.7-0.1-1.3-0.4-1.9-0.9c-0.6-0.5-1-1.1-1.4-1.9C174.8,94.5,174.7,93.8,174.7,93z M180.4,91.6c-0.3-0.3-0.7-0.4-1.1-0.4
			c-0.4,0-0.8,0-1.1,0.2c-0.4,0.2-0.7,0.4-0.9,0.7c-0.2,0.3-0.4,0.7-0.4,1.1c0,0.4,0,0.9,0.2,1.3c0.2,0.5,0.5,0.8,0.8,1.1
			c0.3,0.3,0.7,0.4,1.1,0.5c0.4,0.1,0.8,0,1.1-0.2c0.4-0.2,0.7-0.4,0.9-0.7c0.2-0.3,0.4-0.7,0.4-1.1c0-0.4,0-0.9-0.3-1.3
			C181,92.2,180.7,91.9,180.4,91.6z"
          />
          <path
            d="M184.2,89c0.1-0.7,0.4-1.4,0.9-1.9c0.5-0.6,1.1-1,1.8-1.3c1-0.4,1.9-0.4,2.7-0.2
			c0.8,0.3,1.5,0.8,2,1.6l-2.1,0.8c-0.2-0.3-0.5-0.5-0.9-0.6c-0.3-0.1-0.7-0.1-1.1,0.1c-0.6,0.2-0.9,0.6-1.1,1.1
			c-0.2,0.5-0.1,1.2,0.2,1.9c0.3,0.7,0.7,1.3,1.1,1.6c0.5,0.3,1,0.3,1.6,0.1c0.8-0.3,1.2-0.9,1.2-1.7l2.1-0.8
			c0.1,0.9-0.1,1.8-0.5,2.5c-0.5,0.7-1.2,1.3-2.1,1.6c-0.8,0.3-1.5,0.4-2.2,0.2c-0.7-0.1-1.3-0.4-1.9-0.9s-1-1.1-1.3-2
			S184.1,89.7,184.2,89z"
          />
          <path
            d="M195.1,84.9l1.2,3.9c0.1,0.3,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.1,0.7,0l0.9-0.3l0.5,1.7l-1.3,0.4
			c-1.7,0.5-2.8,0-3.3-1.7l-1.2-3.8l-1,0.3l-0.5-1.7l1-0.3l-0.6-2l2-0.7l0.6,2l1.8-0.6l0.5,1.7L195.1,84.9z"
          />
          <path
            d="M197.6,80.9c-0.3-0.2-0.5-0.4-0.6-0.7c-0.1-0.3-0.1-0.7,0.1-1c0.2-0.3,0.4-0.5,0.8-0.6
			c0.4-0.1,0.7-0.1,1,0.1c0.3,0.2,0.5,0.4,0.6,0.7c0.1,0.3,0.1,0.7-0.1,1s-0.4,0.5-0.8,0.6C198.3,81.1,197.9,81.1,197.6,80.9z
			 M199.9,81.7l2.3,8.1l-2,0.6l-2.3-8.1L199.9,81.7z"
          />
          <path d="M206.9,86.5l0.5-6.8l2.2-0.5l-1,8.9l-2.5,0.6l-5-7.4l2.2-0.5L206.9,86.5z" />
          <path
            d="M210.8,77.7c-0.3-0.2-0.5-0.4-0.5-0.8c-0.1-0.3,0-0.7,0.2-0.9c0.2-0.3,0.5-0.5,0.8-0.5
			c0.4-0.1,0.7,0,1,0.2s0.5,0.4,0.5,0.8c0.1,0.3,0,0.7-0.2,0.9c-0.2,0.3-0.5,0.5-0.8,0.5C211.4,77.9,211.1,77.8,210.8,77.7z
			 M213,78.6l1.7,8.2l-2.1,0.4l-1.7-8.2L213,78.6z"
          />
          <path
            d="M217.8,79.5l0.7,4c0,0.3,0.2,0.5,0.3,0.6c0.2,0.1,0.4,0.1,0.7,0.1l1-0.2l0.3,1.8l-1.3,0.2
			c-1.8,0.3-2.8-0.4-3.1-2.1l-0.7-4l-1,0.2l-0.3-1.7l1-0.2l-0.4-2l2.1-0.4l0.4,2l1.8-0.3l0.3,1.7L217.8,79.5z"
          />
          <path d="M228.9,76.2l-3.6,12.9l-2.2,0.3l1.3-4.4l-4.4-7.7l2.4-0.3l2.9,5.5l1.4-6.1L228.9,76.2z" />
        </g>
      </g>
      <g id="infrastructure">
        <g>
          <path
            id="path-22"
            d="M244.8,244.9l-144-52.5
			c4.4-12.2,9.7-22.6,17-33.3L244.8,244.9L244.8,244.9z"
            data-active={active === 22}
            onClick={() => onClick(22)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(22)}
          />
          <path
            className="filler"
            d="M245.3,245.6l-0.7-0.2l-144.4-52.7l0.2-0.5c4.5-12.3,9.7-22.6,17-33.4l0.3-0.4l127.7,86.2V245.6z
			 M101.5,192.1l139.7,50.9l-123.3-83.3C110.9,170.3,105.8,180.3,101.5,192.1z"
          />
        </g>
        <g>
          <path
            id="path-21"
            d="M244.8,244.9l-152.4-16
			c1.4-12.9,4-24.3,8.4-36.4L244.8,244.9L244.8,244.9z"
            data-active={active === 21}
            onClick={() => onClick(21)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(21)}
          />
          <path
            className="filler"
            d="M245.3,245.5l-0.6,0L91.9,229.3l0.1-0.5c1.4-13,4-24.3,8.4-36.6l0.2-0.5l144.8,52.8V245.5z
			 M93,228.5L240.9,244l-139.7-50.9C96.9,205,94.4,215.9,93,228.5z"
          />
        </g>
        <g>
          <path
            id="path-20"
            d="M244.8,244.9L92.8,263.6
			c-1.6-12.9-1.7-21.8-0.3-34.7L244.8,244.9L244.8,244.9z"
            data-active={active === 20}
            onClick={() => onClick(20)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(20)}
          />
          <path
            className="filler"
            d="M92.3,264.2l-0.1-0.5c-1.6-12.8-1.7-21.9-0.3-34.9l0.1-0.5l0.5,0.1l156.7,16.5L92.3,264.2z
			 M92.9,229.5c-1.3,12.4-1.2,21.3,0.3,33.6L240.4,245L92.9,229.5z"
          />
        </g>
        <g>
          <path
            id="path-19"
            d="M244.8,244.9l-143,55
			c-4.6-12.1-7.5-23.4-9-36.3L244.8,244.9L244.8,244.9z"
            data-active={active === 19}
            onClick={() => onClick(19)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(19)}
          />
          <path
            className="filler"
            d="M101.5,300.6l-0.2-0.5c-4.7-12.2-7.5-23.4-9.1-36.4l-0.1-0.5l0.5-0.1l152.1-18.7h2.7l-2.4,1
			L101.5,300.6z M93.3,264.1c1.6,12.5,4.3,23.4,8.8,35.2l138.8-53.4L93.3,264.1z"
          />
        </g>
        <g>
          <path
            id="path-18"
            d="M244.8,244.9l-125.5,88
			c-7.4-10.6-12.9-20.9-17.5-33L244.8,244.9L244.8,244.9z"
            data-active={active === 18}
            onClick={() => onClick(18)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(18)}
          />
          <path
            className="filler"
            d="M119.2,333.7l-0.3-0.4c-7.5-10.7-12.9-20.9-17.6-33.1l-0.2-0.5l0.5-0.2L248.5,243L119.2,333.7z
			 M102.4,300.2c4.5,11.7,9.8,21.7,17,32l121.8-85.4L102.4,300.2z"
          />
        </g>
        <g id="_x31_8">
          <path d="M126.8,315.1l-1.5,0.8l-1.7-3l10.4-6l0.9,1.6l-8.9,5.1L126.8,315.1L126.8,315.1z" />
          <path
            d="M124.6,308.7c-0.5,0.3-1.1,0.4-1.7,0.3c-0.6,0-1.1-0.3-1.6-0.7c-0.5-0.4-1-1-1.4-1.8
			c-0.4-0.8-0.6-1.5-0.6-2.1s0.2-1.2,0.5-1.7c0.3-0.5,0.7-0.9,1.3-1.1c0.6-0.3,1.1-0.4,1.7-0.3c0.5,0.1,1.1,0.3,1.5,0.6
			c-0.1-0.7,0-1.3,0.4-1.8s0.8-1,1.4-1.3c0.6-0.3,1.3-0.4,1.9-0.4c0.6,0.1,1.3,0.4,1.8,0.8c0.6,0.5,1,1,1.4,1.8
			c0.4,0.7,0.5,1.5,0.6,2.2c0,0.7-0.1,1.3-0.5,1.9c-0.3,0.6-0.8,1-1.5,1.3c-0.6,0.3-1.3,0.4-1.9,0.3c-0.6-0.1-1.2-0.4-1.6-0.8
			C126.3,307.2,125.7,308.1,124.6,308.7L124.6,308.7z M121.1,304.3c-0.1,0.5,0,1,0.3,1.6c0.3,0.6,0.7,1,1.1,1.2
			c0.5,0.2,1,0.2,1.5-0.1c0.5-0.2,0.8-0.6,0.9-1.1c0.1-0.5,0.1-1-0.2-1.6c-0.3-0.6-0.7-0.9-1.2-1.1c-0.5-0.2-1-0.2-1.5,0.1
			C121.6,303.4,121.2,303.8,121.1,304.3L121.1,304.3z M127.3,304.9c0.5,0.3,1.1,0.2,1.7-0.1c0.6-0.3,0.9-0.7,1.1-1.3
			s0.1-1.2-0.3-1.9c-0.3-0.7-0.8-1.1-1.3-1.3c-0.6-0.2-1.1-0.2-1.6,0.1c-0.6,0.3-0.9,0.7-1.1,1.3s0,1.2,0.3,1.8
			C126.3,304.2,126.8,304.7,127.3,304.9L127.3,304.9z"
          />
        </g>
        <g id="_x31_9">
          <path d="M113.6,285.4l-1.6,0.5l-0.9-3.3l11.5-3.3l0.5,1.8l-9.8,2.9L113.6,285.4L113.6,285.4z" />
          <path
            d="M119.2,274.4c0.2-0.4,0.2-0.9,0.1-1.5c-0.2-0.8-0.6-1.2-1.3-1.5c-0.7-0.2-1.7-0.2-3.2,0.2
			c0.4,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.5,0.9,0.6,1.4c0.2,0.7,0.2,1.4,0,2c-0.2,0.6-0.5,1.2-1,1.6c-0.5,0.5-1.1,0.8-1.9,0.9
			c-1.2,0.3-2.2,0.1-3-0.4c-0.8-0.5-1.4-1.4-1.7-2.6c-0.3-1.5-0.1-2.6,0.8-3.4c0.8-0.8,2.2-1.5,4.2-1.9c1.4-0.3,2.5-0.4,3.5-0.4
			c0.9,0,1.7,0.3,2.3,0.7c0.6,0.5,1,1.2,1.2,2.2c0.3,1.1,0.2,2.1-0.3,2.8c-0.5,0.7-1.1,1.3-2,1.5l-0.4-1.7
			C118.7,275.1,119,274.8,119.2,274.4L119.2,274.4z M114,272.6c-0.5-0.3-1.1-0.3-1.7-0.2c-0.7,0.2-1.3,0.5-1.6,1
			c-0.3,0.5-0.4,1.1-0.3,1.7c0.2,0.7,0.5,1.2,1,1.5c0.5,0.3,1.1,0.4,1.8,0.2c0.6-0.1,1.1-0.5,1.5-0.9c0.3-0.5,0.4-1.1,0.2-1.9
			C114.8,273.3,114.5,272.9,114,272.6L114,272.6z"
          />
        </g>
        <g id="_x32_0">
          <path
            d="M115.5,253.8c-1-1-1.7-1.8-2.4-2.4c-0.6-0.6-1.2-1.1-1.9-1.4c-0.6-0.4-1.3-0.6-1.9-0.5
			c-0.6,0-1.2,0.2-1.5,0.5c-0.4,0.3-0.5,0.8-0.5,1.5c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.7,0.5l0.1,1.8c-1.2,0-2.2-0.3-2.9-1
			c-0.7-0.7-1.1-1.6-1.1-2.7c-0.1-1.2,0.2-2.1,0.8-2.8c0.6-0.7,1.5-1.1,2.6-1.1c0.8,0,1.6,0.1,2.3,0.5c0.7,0.4,1.4,0.8,2,1.3
			c0.6,0.5,1.3,1.2,2.1,2l0.7,0.7L116,247l1.6-0.1l0.4,8l-1.4,0.1L115.5,253.8L115.5,253.8z"
          />
          <path
            d="M107.2,244.3c-1.1-0.7-1.6-1.8-1.5-3.3c0-1.6,0.6-2.7,1.7-3.3c1.1-0.6,2.6-0.9,4.5-0.9
			c1.9,0,3.4,0.4,4.5,1.1c1.1,0.7,1.6,1.8,1.6,3.3c0,1.6-0.6,2.7-1.7,3.3c-1.1,0.6-2.6,0.9-4.5,0.9
			C109.8,245.3,108.3,245,107.2,244.3L107.2,244.3z M109.5,238.8c-0.6,0.1-1.1,0.3-1.5,0.7c-0.4,0.3-0.6,0.9-0.6,1.6
			c0,0.7,0.2,1.2,0.6,1.6c0.4,0.4,0.9,0.6,1.5,0.7c0.6,0.1,1.4,0.2,2.2,0.2c0.9,0,1.7,0,2.3-0.1c0.6-0.1,1.1-0.3,1.5-0.7
			c0.4-0.4,0.6-0.9,0.6-1.6c0-0.7-0.2-1.2-0.5-1.6c-0.4-0.4-0.9-0.6-1.5-0.7c-0.6-0.1-1.4-0.2-2.3-0.2
			C110.9,238.6,110.2,238.7,109.5,238.8L109.5,238.8z"
          />
        </g>
        <g id="_x32_1">
          <path
            d="M117.4,221.5c-0.7-1.2-1.2-2.2-1.7-2.9c-0.5-0.7-0.9-1.3-1.5-1.9c-0.5-0.5-1.1-0.8-1.7-1
			c-0.6-0.1-1.2-0.1-1.6,0.2c-0.4,0.2-0.7,0.7-0.8,1.3c-0.1,0.6,0,1.2,0.3,1.6c0.3,0.4,0.8,0.7,1.5,0.9l-0.4,1.8
			c-1.2-0.3-2.1-0.8-2.6-1.7c-0.5-0.8-0.6-1.8-0.4-2.9c0.2-1.2,0.7-2,1.5-2.5c0.8-0.5,1.7-0.7,2.8-0.5c0.8,0.2,1.5,0.5,2.1,1
			c0.6,0.5,1.2,1.1,1.6,1.8c0.5,0.6,1,1.5,1.5,2.5l0.5,0.9l1-5.1l1.5,0.3l-1.6,7.8l-1.3-0.3L117.4,221.5L117.4,221.5z"
          />
          <path d="M111.6,211.5l-1.7-0.4l0.9-3.3l11.6,3.1l-0.5,1.8L112,210L111.6,211.5L111.6,211.5z" />
        </g>
        <g id="_x32_2">
          <path
            d="M125.6,194c-0.4-1.3-0.7-2.4-1-3.2c-0.3-0.8-0.6-1.5-1-2.1c-0.4-0.6-0.9-1.1-1.5-1.3
			c-0.6-0.3-1.1-0.3-1.6-0.2c-0.5,0.1-0.8,0.5-1.1,1.1c-0.3,0.6-0.3,1.1-0.1,1.6c0.2,0.5,0.6,0.9,1.3,1.2l-0.7,1.7
			c-1.1-0.5-1.8-1.3-2.1-2.2c-0.3-0.9-0.2-1.9,0.2-2.9c0.5-1.1,1.2-1.8,2-2.1c0.9-0.3,1.8-0.3,2.8,0.2c0.7,0.3,1.3,0.8,1.8,1.5
			c0.5,0.7,0.9,1.4,1.2,2.1c0.3,0.7,0.6,1.7,0.9,2.7l0.3,0.9l2.1-4.7l1.4,0.6l-3.3,7.3l-1.2-0.6L125.6,194L125.6,194z"
          />
          <path
            d="M129.6,185.5c-0.3-1.4-0.6-2.4-0.8-3.2c-0.2-0.8-0.5-1.6-0.9-2.2c-0.4-0.7-0.8-1.1-1.4-1.4
			c-0.6-0.3-1.1-0.4-1.6-0.3c-0.5,0.1-0.9,0.4-1.2,1c-0.3,0.6-0.4,1.1-0.2,1.6c0.2,0.5,0.6,0.9,1.2,1.3l-0.9,1.6
			c-1.1-0.6-1.7-1.4-2-2.4c-0.2-0.9-0.1-1.9,0.4-2.9c0.6-1,1.3-1.7,2.2-2c0.9-0.3,1.8-0.2,2.8,0.4c0.7,0.4,1.3,0.9,1.7,1.6
			c0.5,0.7,0.8,1.4,1,2.2s0.5,1.7,0.7,2.8l0.2,1l2.5-4.6l1.4,0.7l-3.8,7l-1.2-0.6L129.6,185.5L129.6,185.5z"
          />
        </g>
        <path
          className="spacer"
          d="M118.8,335.7l-1.1-1.6c-7.6-10.8-13-21.2-17.8-33.5c-4.7-12.3-7.6-23.7-9.2-36.8
		c-1.6-13-1.7-22.2-0.3-35.2c1.4-13.1,4-24.5,8.5-36.9c4.5-12.4,9.8-22.8,17.2-33.8l1.1-1.7l131.1,88.6L118.8,335.7z M118.4,161.9
		c-6.6,10.1-11.5,19.8-15.6,31.2c-4.4,12.1-7,23.2-8.3,36c-1.3,12.6-1.2,21.6,0.3,34.3c1.6,12.8,4.3,23.8,8.9,35.8
		c4.4,11.4,9.4,21,16.2,31L241.3,245L118.4,161.9z"
        />
        <g id="icon-infrastructure">
          <rect
            x="26.6"
            y="261.3"
            transform="matrix(0.1524 -0.9883 0.9883 0.1524 -227.3447 259.4638)"
            width="22.1"
            height="2"
          />

          <rect
            x="55.3"
            y="251.2"
            transform="matrix(0.9883 -0.1523 0.1523 0.9883 -39.2932 11.636)"
            width="2"
            height="22.1"
          />
          <rect x="45.9" y="268.4" width="2" height="3.9" />
          <rect x="45.9" y="253" width="2" height="3.9" />
          <rect x="45.9" y="260.7" width="2" height="3.9" />
        </g>
        <g className="label" data-active={isInRange(active, 18, 22)}>
          <path d="M84.7,307.8l9.8-3.8l0.8,2l-9.8,3.8L84.7,307.8z" />
          <path
            d="M84.4,298.1c0.4-0.8,1.1-1.4,2.2-1.7l4.7-1.6l0.7,2l-4.4,1.5c-0.6,0.2-1.1,0.5-1.3,1
			c-0.2,0.4-0.3,0.9-0.1,1.5c0.2,0.6,0.5,0.9,1,1.1c0.4,0.2,1,0.2,1.6,0l4.4-1.5l0.7,2l-7.9,2.7l-0.7-2l1-0.3
			c-0.4-0.1-0.8-0.4-1.2-0.7c-0.3-0.3-0.6-0.8-0.8-1.3C83.9,299.7,84,298.8,84.4,298.1z"
          />
          <path
            d="M83.3,291.2l0.4,1.4l6.4-1.9l0.6,2.1l-6.4,1.9l0.3,0.9l-1.7,0.5l-0.3-0.9l-0.4,0.1
			c-1,0.3-1.8,0.2-2.4-0.2c-0.6-0.4-1.1-1.2-1.4-2.4l1.7-0.5c0.1,0.5,0.3,0.8,0.5,1c0.2,0.1,0.6,0.1,1,0l0.3-0.1l-0.4-1.4
			L83.3,291.2z"
          />
          <path
            d="M80.7,287.2c-0.4-0.4-0.6-0.8-0.7-1.4l2.2-0.6l0.1,0.5c0.2,0.6,0.4,1.1,0.8,1.3
			c0.4,0.2,1,0.3,1.7,0.1l4-1l0.5,2.1l-8.1,2.1l-0.5-2.1L82,288C81.5,287.8,81.1,287.6,80.7,287.2z"
          />
          <path
            d="M81.6,284c-0.7-0.2-1.3-0.5-1.8-1c-0.5-0.5-0.8-1.1-0.9-1.8c-0.1-0.6-0.1-1.2,0-1.7
			c0.2-0.5,0.4-0.9,0.7-1.3l-1.2,0.2l-0.4-2.1l8.2-1.7l0.4,2.1l-1.2,0.2c0.4,0.2,0.8,0.5,1.2,0.9c0.3,0.4,0.6,0.9,0.7,1.5
			c0.1,0.7,0.1,1.4-0.1,2c-0.2,0.6-0.6,1.2-1.2,1.7c-0.6,0.5-1.3,0.8-2.1,1C83.1,284.2,82.3,284.2,81.6,284z M81.4,278.1
			c-0.3,0.3-0.5,0.6-0.7,1c-0.1,0.4-0.1,0.8-0.1,1.1c0.1,0.4,0.2,0.7,0.5,1c0.3,0.3,0.6,0.5,1,0.6c0.4,0.1,0.9,0.1,1.3,0
			s0.9-0.3,1.2-0.6c0.3-0.3,0.6-0.6,0.7-1s0.2-0.7,0.1-1.1c-0.1-0.4-0.2-0.7-0.5-1c-0.3-0.3-0.6-0.5-1-0.6c-0.4-0.1-0.9-0.1-1.4,0
			C82.1,277.6,81.7,277.8,81.4,278.1z"
          />
          <path
            d="M85.6,271.5c-0.2,0.6-0.4,1.1-0.8,1.4c-0.4,0.4-0.8,0.6-1.3,0.7l-0.3-2.1c0.3-0.1,0.6-0.3,0.7-0.6
			c0.2-0.3,0.2-0.7,0.2-1.1c-0.1-0.4-0.2-0.7-0.4-0.9c-0.2-0.2-0.4-0.3-0.7-0.2c-0.3,0-0.5,0.2-0.5,0.5c-0.1,0.3-0.2,0.8-0.2,1.4
			c-0.1,0.6-0.1,1.2-0.2,1.6c-0.1,0.4-0.3,0.8-0.6,1.1c-0.3,0.3-0.7,0.5-1.3,0.6c-0.5,0.1-0.9,0-1.3-0.2c-0.4-0.2-0.8-0.5-1.1-1
			c-0.3-0.5-0.5-1-0.6-1.7c-0.1-1,0-1.8,0.4-2.5c0.4-0.7,1-1.1,1.9-1.3l0.3,2c-0.3,0.1-0.6,0.3-0.7,0.5c-0.2,0.3-0.2,0.6-0.1,1
			c0.1,0.4,0.2,0.7,0.3,0.8c0.2,0.2,0.4,0.3,0.6,0.2c0.3,0,0.5-0.2,0.6-0.5c0.1-0.3,0.2-0.8,0.2-1.4c0.1-0.6,0.1-1.1,0.2-1.6
			c0.1-0.4,0.3-0.8,0.6-1.1c0.3-0.3,0.7-0.5,1.3-0.6c0.5-0.1,0.9,0,1.3,0.2c0.4,0.2,0.8,0.5,1.1,1c0.3,0.5,0.5,1,0.6,1.7
			C85.8,270.3,85.7,270.9,85.6,271.5z"
          />
          <path
            d="M78,263.2l4-0.4c0.3,0,0.5-0.1,0.6-0.3c0.1-0.1,0.1-0.4,0.1-0.7l-0.1-1l1.8-0.2l0.1,1.3
			c0.2,1.8-0.6,2.8-2.3,2.9l-4,0.4l0.1,1l-1.7,0.2l-0.1-1l-2.1,0.2l-0.2-2.1l2.1-0.2l-0.2-1.9l1.7-0.2L78,263.2z"
          />
          <path
            d="M76,256.7c-0.3-0.4-0.4-0.9-0.5-1.5l2.2-0.2l0,0.6c0,0.7,0.2,1.2,0.6,1.5c0.3,0.3,0.9,0.4,1.7,0.4
			l4.2-0.3l0.1,2.1l-8.4,0.6l-0.1-2.1l1.3-0.1C76.6,257.5,76.3,257.1,76,256.7z"
          />
          <path
            d="M75.3,245.8l8.4-0.2l0,2.1l-1.1,0c0.4,0.3,0.7,0.6,0.9,1s0.3,0.9,0.3,1.4c0,0.7-0.1,1.2-0.4,1.8
			c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1.2,0.5-1.9,0.5l-4.9,0.1l0-2.1l4.6-0.1c0.7,0,1.2-0.2,1.5-0.5c0.4-0.3,0.5-0.8,0.5-1.4
			c0-0.6-0.2-1-0.6-1.4c-0.4-0.3-0.9-0.5-1.5-0.5l-4.6,0.1L75.3,245.8z"
          />
          <path
            d="M77.3,243.6c-0.6-0.4-1.1-0.9-1.5-1.5c-0.3-0.6-0.5-1.4-0.5-2.2c0-1,0.3-1.9,0.9-2.6
			c0.5-0.7,1.3-1.1,2.2-1.3l-0.1,2.3c-0.4,0.1-0.7,0.3-0.9,0.6s-0.3,0.6-0.3,1.1c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.6,1.9,0.6
			c0.8,0,1.4-0.1,1.9-0.5c0.5-0.3,0.7-0.8,0.7-1.4c0-0.9-0.3-1.4-1.1-1.7l0.1-2.3c0.9,0.3,1.6,0.7,2.1,1.5c0.5,0.7,0.7,1.6,0.7,2.6
			c0,0.8-0.2,1.5-0.6,2.1c-0.4,0.6-0.9,1.1-1.6,1.4c-0.7,0.3-1.4,0.5-2.3,0.5C78.7,244.1,77.9,243.9,77.3,243.6z"
          />
          <path
            d="M77.7,232l4,0.3c0.3,0,0.5,0,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.7l0.1-1l1.8,0.1l-0.1,1.3
			c-0.1,1.8-1.1,2.6-2.8,2.5l-4-0.3l-0.1,1l-1.7-0.1l0.1-1l-2.1-0.2l0.2-2.1l2.1,0.2l0.1-1.9l1.7,0.1L77.7,232z"
          />
          <path
            d="M77.2,220.4l8.3,1.1l-0.3,2.1l-1.1-0.1c0.3,0.3,0.6,0.7,0.7,1.2c0.1,0.5,0.2,0.9,0.1,1.5
			c-0.1,0.7-0.3,1.2-0.6,1.7c-0.3,0.5-0.8,0.8-1.4,1c-0.6,0.2-1.2,0.3-2,0.2l-4.9-0.6l0.3-2.1l4.6,0.6c0.7,0.1,1.2,0,1.6-0.3
			c0.4-0.3,0.6-0.7,0.7-1.3c0.1-0.6,0-1.1-0.4-1.4c-0.3-0.4-0.8-0.6-1.5-0.7l-4.6-0.6L77.2,220.4z"
          />
          <path
            d="M78.4,215.2c-0.2-0.5-0.2-1-0.1-1.5l2.2,0.4l-0.1,0.6c-0.1,0.7,0,1.2,0.2,1.6
			c0.2,0.4,0.8,0.6,1.5,0.8l4.1,0.7l-0.4,2.1l-8.3-1.5l0.4-2.1l1.3,0.2C78.9,216,78.6,215.6,78.4,215.2z"
          />
          <path
            d="M85.1,205.6l-1.3,6c0.6,0.1,1.1,0,1.5-0.3c0.4-0.3,0.7-0.7,0.8-1.2c0.2-0.8,0-1.4-0.6-1.9L86,206
			c0.7,0.4,1.3,1,1.6,1.8s0.4,1.7,0.2,2.6c-0.2,0.8-0.5,1.5-1,2s-1.1,0.9-1.8,1.1c-0.7,0.2-1.5,0.2-2.3,0c-0.8-0.2-1.6-0.5-2.1-1
			c-0.6-0.5-0.9-1.1-1.2-1.8c-0.2-0.7-0.2-1.5,0-2.3c0.2-0.8,0.5-1.4,1-2c0.5-0.5,1.1-0.9,1.7-1.1c0.7-0.2,1.4-0.2,2.2,0
			C84.6,205.5,84.9,205.5,85.1,205.6z M83.3,207.4c-0.5-0.1-1,0-1.4,0.3s-0.7,0.7-0.8,1.3c-0.1,0.5-0.1,1,0.2,1.4
			c0.2,0.4,0.6,0.7,1.1,0.9L83.3,207.4z"
          />
        </g>
      </g>
      <g id="technology">
        <g>
          <path
            id="path-17"
            d="M244.8,244.9L144.3,360.8
			c-9.8-8.5-17.6-17.2-25-27.8L244.8,244.9L244.8,244.9z"
            data-active={active === 17}
            onClick={() => onClick(17)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(17)}
          />
          <path
            className="spacer"
            d="M144.4,361.5l-0.4-0.3c-9.8-8.6-17.6-17.2-25.1-27.9l-0.3-0.4l0.4-0.3l125.8-88.3l0.6,0.6l-0.3,0.4
			L144.4,361.5z M120,333.1c7.3,10.3,14.8,18.7,24.2,27l97.6-112.4L120,333.1z"
          />
        </g>
        <g>
          <path
            id="path-16"
            d="M244.8,244.9l-69.6,136.7
			c-11.5-5.9-21.2-12.4-31-20.9L244.8,244.9z"
            data-active={active === 16}
            onClick={() => onClick(16)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(16)}
          />
          <path
            className="filler"
            d="M175.5,382.4l-0.4-0.2c-11.6-5.9-21.2-12.4-31.1-21l-0.4-0.3l103.5-119.3L175.5,382.4z M145,360.7
			c9.5,8.2,18.8,14.5,30,20.3l67.5-132.7L145,360.7z"
          />
        </g>
        <g>
          <path
            id="path-15"
            d="M244.8,244.9l-34.5,149.5
			c-12.6-2.9-23.6-6.9-35.1-12.8L244.8,244.9L244.8,244.9z"
            data-active={active === 15}
            onClick={() => onClick(15)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(15)}
          />
          <path
            className="filler"
            d="M210.7,395.1l-0.5-0.1c-12.7-2.9-23.6-6.9-35.2-12.8l-0.4-0.2l0.2-0.4l71.4-140.4L210.7,395.1z
			 M175.9,381.5c11.3,5.7,21.8,9.6,34,12.4l33.4-145.1L175.9,381.5z"
          />
        </g>
        <g>
          <path
            id="path-14"
            d="M244.8,244.9v153.5
			c-12.9,0-21.8-1-34.5-3.9L244.8,244.9L244.8,244.9z"
            data-active={active === 14}
            onClick={() => onClick(14)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(14)}
          />
          <path
            className="filler"
            d="M245.3,398.9h-0.5c-12.9,0-22-1-34.6-3.9l-0.5-0.1l35.6-154.3V398.9z M211,394.1
			c12.1,2.8,21,3.8,33.4,3.8V249.3L211,394.1z"
          />
        </g>
        <g>
          <path
            id="path-13"
            d="M244.8,244.9l37.1,148.9
			c-12.6,3.1-24.1,4.6-37.1,4.6V244.9L244.8,244.9z"
            data-active={active === 13}
            onClick={() => onClick(13)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(13)}
          />
          <path
            className="filler"
            d="M244.8,398.9h-0.5v-158l38.2,153.3l-0.5,0.1C269.3,397.5,257.9,398.9,244.8,398.9z M245.3,249
			v148.9c12.6,0,23.7-1.4,36-4.4L245.3,249z"
          />
        </g>
        <g id="_x31_3">
          <path d="M267.8,380.5l0.3,1.7l-3.4,0.5l-1.8-11.8l1.9-0.3l1.6,10.1L267.8,380.5L267.8,380.5z" />
          <path
            d="M260.4,382.7c-0.7,0.6-1.6,1-2.7,1.1c-0.8,0.1-1.4,0-2-0.2c-0.6-0.2-1-0.6-1.4-1
			c-0.3-0.4-0.5-1-0.6-1.5c-0.1-0.7,0.1-1.3,0.4-1.8c0.3-0.5,0.7-0.9,1.2-1.1v-0.1c-0.7-0.1-1.2-0.5-1.6-0.9s-0.6-1.1-0.7-1.9
			c-0.1-0.6,0-1.2,0.3-1.8c0.2-0.5,0.6-1,1.2-1.3c0.6-0.3,1.2-0.6,2-0.6c1.2-0.1,2.2,0.1,3,0.6c0.8,0.5,1.3,1.4,1.5,2.5l-1.8,0.2
			c-0.1-0.6-0.4-1-0.8-1.4c-0.4-0.3-1-0.5-1.7-0.4c-0.7,0.1-1.2,0.3-1.5,0.7c-0.3,0.4-0.5,0.9-0.4,1.5c0.1,0.8,0.4,1.3,0.9,1.6
			c0.5,0.3,1.3,0.4,2.3,0.3l0.4,0l0.1,1.5l-0.4,0c-0.9,0.1-1.5,0.3-2,0.6c-0.4,0.3-0.6,0.8-0.6,1.4c0,0.5,0.3,0.9,0.6,1.2
			c0.4,0.3,0.9,0.4,1.5,0.3c0.6-0.1,1.1-0.3,1.4-0.6c0.3-0.3,0.5-0.7,0.5-1.2l1.8-0.2C261.4,381.3,261.1,382.1,260.4,382.7
			L260.4,382.7z"
          />
        </g>
        <g id="_x31_4">
          <path d="M237.7,382.3l-0.1,1.7l-3.4-0.2l0.8-11.9l1.9,0.1l-0.7,10.2L237.7,382.3L237.7,382.3z" />
          <path
            d="M232.5,374.2l-0.2,1.4l-6.5,7.1l-2.2-0.3l1-7.6l-1.5-0.2l0.2-1.6l1.5,0.2l0.3-2.5l1.8,0.2l-0.3,2.5
			L232.5,374.2L232.5,374.2z M225.5,380.7l4.6-5.2l-3.8-0.5L225.5,380.7L225.5,380.7z"
          />
        </g>
        <g id="_x31_5">
          <path d="M204.7,376.5l-0.5,1.6l-3.2-1l3.7-11.4l1.8,0.6l-3.1,9.8L204.7,376.5L204.7,376.5z" />
          <path
            d="M191.4,371.8l5.1,2l1.2-3c-0.3,0.2-0.7,0.3-1.2,0.3c-0.5,0-1-0.1-1.5-0.2c-0.9-0.3-1.5-0.8-1.9-1.4
			c-0.4-0.6-0.6-1.2-0.6-1.8s0.1-1.3,0.4-1.9c0.3-0.7,0.7-1.4,1.2-1.8s1.1-0.8,1.8-0.9c0.7-0.1,1.5,0,2.3,0.3
			c1.1,0.4,1.9,1.1,2.3,1.9c0.5,0.8,0.6,1.7,0.4,2.7l-1.7-0.7c0.1-0.5,0-1-0.3-1.4c-0.3-0.4-0.7-0.8-1.3-1c-0.7-0.3-1.4-0.3-1.9,0
			c-0.5,0.3-0.9,0.8-1.2,1.5c-0.3,0.7-0.3,1.4-0.1,1.9c0.2,0.5,0.7,0.9,1.4,1.2c0.5,0.2,1,0.2,1.4,0.1c0.4-0.1,0.8-0.4,1.1-0.7
			l1.6,0.7l-2.5,6.4l-6.7-2.6L191.4,371.8L191.4,371.8z"
          />
        </g>
        <g id="_x31_6">
          <path d="M174.6,363.1l-0.9,1.5l-2.9-1.8l6.3-10.2l1.6,1l-5.4,8.7L174.6,363.1L174.6,363.1z" />
          <path
            d="M164.4,356.5c0.1,0.4,0.4,0.7,0.9,1.1c0.7,0.5,1.4,0.6,2.2,0.3c0.7-0.3,1.6-1.1,2.4-2.3
			c-0.5,0.2-1.1,0.3-1.7,0.2c-0.6-0.1-1.2-0.3-1.7-0.7c-0.6-0.4-1-0.9-1.3-1.5c-0.3-0.6-0.4-1.2-0.3-1.9c0.1-0.7,0.4-1.3,0.8-2
			c0.4-0.6,1-1.1,1.6-1.4c0.6-0.3,1.2-0.5,1.9-0.4c0.7,0.1,1.4,0.3,2,0.8c0.9,0.6,1.5,1.4,1.7,2.1s0.2,1.6-0.1,2.5
			c-0.3,0.9-0.9,1.9-1.6,3c-2.3,3.3-4.6,4.1-6.9,2.5c-0.9-0.6-1.4-1.4-1.6-2.2c-0.2-0.8-0.1-1.7,0.4-2.4l1.4,1
			C164.3,355.6,164.3,356.1,164.4,356.5L164.4,356.5z M169.5,354.5c0.6-0.1,1.1-0.4,1.6-1c0.4-0.6,0.6-1.2,0.5-1.8
			c-0.1-0.6-0.5-1.1-1.1-1.6c-0.6-0.4-1.1-0.5-1.7-0.4c-0.6,0.1-1.1,0.5-1.5,1c-0.4,0.6-0.6,1.2-0.5,1.8c0.1,0.6,0.4,1.1,1,1.5
			C168.3,354.4,168.9,354.5,169.5,354.5z"
          />
        </g>
        <g id="_x31_7">
          <path d="M148.1,342.5l-1.2,1.2l-2.4-2.4l8.5-8.3l1.3,1.4l-7.3,7.2L148.1,342.5L148.1,342.5z" />
          <path d="M138.5,332.3l10.9-3.5l1.2,1.4l-10.8,3.3l4,4.6l-1.2,1l-5.2-6L138.5,332.3L138.5,332.3z" />
        </g>
        <path
          className="spacer"
          d="M244.8,400.4c-13.1,0-22.3-1-34.9-4c-12.9-3-23.8-7-35.5-13c-11.8-6-21.4-12.5-31.4-21.2
		c-9.9-8.7-17.8-17.4-25.3-28.2l-1.1-1.6l128.5-90.1l1.6,1.6l0.1,0.5l37.5,150.8l-1.9,0.5C269.6,399,258,400.4,244.8,400.4z
		 M122.1,333.5c7,9.8,14.3,17.8,23.5,25.8c9.7,8.4,19.1,14.8,30.6,20.6c11.4,5.8,22.1,9.7,34.6,12.6c12.3,2.9,21.2,3.9,34,3.9
		c12.2,0,22.9-1.2,34.6-4l-35.9-144.1L122.1,333.5z"
        />
        <g id="icon-technology">
          <path
            d="M170.4,440.4c-0.8,0-1.6-0.1-2.3-0.2l-0.7-0.1l-0.2-2.3c-1-0.4-1.9-0.9-2.8-1.6l-2.1,1l-0.5-0.5
			c-1.1-1.2-1.9-2.5-2.4-4.1l-0.2-0.7l1.9-1.4c-0.1-0.5-0.1-1.1-0.1-1.6s0-1.1,0.1-1.6l-1.9-1.4l0.2-0.7c0.5-1.5,1.3-2.9,2.4-4.1
			l0.5-0.5l2.1,1c0.8-0.7,1.8-1.2,2.8-1.6l0.2-2.3l0.7-0.1c1.5-0.3,3.1-0.3,4.7,0l0.7,0.1l0.2,2.3c1,0.4,1.9,0.9,2.8,1.6l2.1-1
			l0.5,0.5c1.1,1.2,1.9,2.5,2.4,4.1l0.2,0.7l-1.9,1.4c0.1,0.5,0.1,1.1,0.1,1.6s0,1.1-0.1,1.6l1.9,1.4l-0.2,0.7
			c-0.5,1.5-1.3,2.9-2.4,4.1l-0.5,0.5l-2.1-1c-0.8,0.7-1.8,1.2-2.8,1.6l-0.2,2.3l-0.7,0.1C171.9,440.3,171.2,440.4,170.4,440.4z
			 M169.1,438.3c0.8,0.1,1.6,0.1,2.5,0l0.2-2.2l0.6-0.2c1.1-0.3,2.2-0.9,3.1-1.8l0.5-0.5l2,0.9c0.5-0.6,0.9-1.4,1.2-2.1l-1.8-1.3
			l0.2-0.7c0.1-0.6,0.2-1.2,0.2-1.8s-0.1-1.2-0.2-1.8l-0.2-0.7l1.8-1.3c-0.3-0.8-0.7-1.5-1.2-2.1l-2,0.9l-0.5-0.5
			c-0.9-0.8-1.9-1.5-3.1-1.8l-0.6-0.2l-0.2-2.2c-0.8-0.1-1.6-0.1-2.5,0l-0.2,2.2l-0.6,0.2c-1.2,0.3-2.2,1-3.1,1.8l-0.5,0.5l-2-0.9
			c-0.5,0.7-0.9,1.4-1.2,2.1l1.8,1.3l-0.2,0.7c-0.1,0.6-0.2,1.2-0.2,1.8s0.1,1.2,0.2,1.8l0.2,0.7l-1.8,1.3c0.3,0.8,0.7,1.5,1.2,2.1
			l2-0.9l0.5,0.5c0.9,0.8,1.9,1.5,3.1,1.8l0.6,0.2L169.1,438.3z"
          />
        </g>
        <g className="label" data-active={isInRange(active, 13, 17)}>
          <path d="M220,416.9l0.2-1.7l2.8,0.4l1.1-8.8l2.1,0.3l-1.1,8.8l2.8,0.4l-0.2,1.7L220,416.9z" />
          <path
            d="M211.9,408.3l6,1.1c0.1-0.6-0.1-1.1-0.4-1.5c-0.3-0.4-0.7-0.7-1.3-0.8c-0.8-0.1-1.4,0.1-1.8,0.7
			l-2.2-0.4c0.4-0.8,1-1.3,1.7-1.7c0.8-0.4,1.6-0.5,2.6-0.3c0.8,0.1,1.5,0.5,2,0.9c0.6,0.5,1,1.1,1.2,1.8s0.3,1.5,0.1,2.3
			c-0.2,0.9-0.5,1.6-0.9,2.2c-0.5,0.6-1,1-1.7,1.2c-0.7,0.2-1.4,0.3-2.3,0.1c-0.8-0.1-1.5-0.4-2-0.9c-0.6-0.5-0.9-1-1.2-1.7
			s-0.3-1.4-0.1-2.2C211.7,408.8,211.8,408.5,211.9,408.3z M213.7,410.1c-0.1,0.5,0,1,0.3,1.4c0.3,0.4,0.7,0.6,1.3,0.7
			c0.5,0.1,1,0,1.4-0.2c0.4-0.2,0.7-0.6,0.9-1.2L213.7,410.1z"
          />
          <path
            d="M209.7,410.8c-0.5,0.6-1.1,0.9-1.8,1.1c-0.7,0.2-1.4,0.2-2.2,0c-1-0.2-1.8-0.7-2.3-1.4
			c-0.5-0.7-0.8-1.5-0.8-2.4l2.2,0.5c0,0.4,0.2,0.7,0.4,1c0.2,0.3,0.6,0.5,1,0.6c0.6,0.1,1.1,0,1.6-0.3c0.4-0.3,0.8-0.9,1-1.7
			c0.2-0.8,0.2-1.4-0.1-1.9c-0.2-0.5-0.7-0.8-1.2-1c-0.8-0.2-1.5,0-1.9,0.7l-2.2-0.5c0.4-0.8,1.1-1.4,1.8-1.8
			c0.8-0.4,1.7-0.4,2.7-0.2c0.8,0.2,1.4,0.5,2,1s0.9,1.1,1.1,1.8s0.2,1.5,0,2.3C210.6,409.6,210.2,410.3,209.7,410.8z"
          />
          <path
            d="M194.2,408.3c-0.4-0.4-0.6-0.9-0.8-1.5c-0.1-0.6-0.1-1.3,0.2-2l1.4-4.7l2,0.6l-1.3,4.4
			c-0.2,0.6-0.2,1.2,0,1.6c0.2,0.4,0.6,0.7,1.1,0.9c0.6,0.2,1.1,0.1,1.5-0.1c0.4-0.2,0.7-0.7,0.9-1.3l1.3-4.4l2,0.6l-3.2,10.7
			l-2-0.6l1.1-3.7c-0.4,0.3-0.8,0.4-1.3,0.5c-0.5,0.1-1,0-1.5-0.1C195.1,409,194.6,408.7,194.2,408.3z"
          />
          <path
            d="M184.2,404.2c-0.4-0.8-0.3-1.7,0-2.8l1.7-4.6l2,0.7l-1.6,4.3c-0.2,0.6-0.3,1.2-0.1,1.6
			s0.6,0.8,1.1,1c0.5,0.2,1,0.2,1.5,0c0.4-0.2,0.8-0.6,1-1.3l1.6-4.3l2,0.7l-2.9,7.9l-2-0.7l0.4-1c-0.4,0.2-0.8,0.4-1.3,0.4
			s-1,0-1.5-0.2C185.2,405.6,184.5,405,184.2,404.2z"
          />
          <path
            d="M182.8,395.9c0.4,0.6,0.7,1.3,0.8,2c0.1,0.7-0.1,1.5-0.4,2.3c-0.3,0.8-0.8,1.4-1.4,1.9
			c-0.6,0.5-1.3,0.7-2,0.8c-0.7,0.1-1.5-0.1-2.2-0.4c-0.7-0.3-1.3-0.8-1.8-1.4c-0.5-0.6-0.7-1.3-0.8-2c-0.1-0.8,0-1.5,0.4-2.3
			c0.3-0.8,0.8-1.4,1.4-1.8c0.6-0.4,1.3-0.7,2.1-0.8c0.8-0.1,1.5,0.1,2.2,0.4C181.7,394.8,182.3,395.3,182.8,395.9z M179.1,396
			c-0.4,0-0.7,0.2-1.1,0.4c-0.3,0.3-0.6,0.6-0.8,1.1c-0.3,0.7-0.4,1.4-0.2,1.9c0.2,0.6,0.6,1,1.2,1.2c0.6,0.2,1.1,0.2,1.7,0
			c0.5-0.2,1-0.7,1.3-1.4c0.3-0.7,0.4-1.4,0.2-1.9c-0.2-0.6-0.6-1-1.1-1.2C179.9,396.1,179.5,396,179.1,396z"
          />
          <path d="M169,401.4l4.9-10.1l1.9,0.9l-4.9,10.1L169,401.4z" />
          <path
            d="M170.7,390.2c0.4,0.6,0.6,1.3,0.6,2.1c0,0.8-0.2,1.5-0.6,2.3c-0.4,0.8-0.9,1.3-1.6,1.7
			c-0.6,0.4-1.3,0.6-2.1,0.6c-0.7,0-1.5-0.2-2.2-0.6c-0.7-0.4-1.3-0.9-1.7-1.5c-0.4-0.6-0.6-1.3-0.6-2.1c0-0.8,0.2-1.5,0.6-2.3
			s0.9-1.3,1.6-1.7c0.7-0.4,1.4-0.6,2.1-0.6c0.8,0,1.5,0.2,2.2,0.6C169.7,389.1,170.3,389.6,170.7,390.2z M167,390
			c-0.4,0-0.8,0.1-1.1,0.4c-0.4,0.2-0.7,0.6-0.9,1.1c-0.4,0.7-0.5,1.3-0.3,1.9s0.5,1,1,1.3c0.5,0.3,1.1,0.3,1.6,0.2
			c0.6-0.2,1-0.6,1.4-1.3c0.4-0.7,0.5-1.3,0.3-1.9c-0.1-0.6-0.5-1-1-1.3C167.8,390.1,167.4,390,167,390z"
          />
          <path
            d="M155.5,390.4c-0.3-0.5-0.4-0.9-0.4-1.4l-0.6,1l-1.8-1.1l4.4-7.2c0.4-0.7,0.9-1.2,1.5-1.5
			c0.6-0.4,1.2-0.5,2-0.5c0.7,0,1.5,0.3,2.2,0.7c1,0.6,1.7,1.4,2.1,2.2c0.4,0.9,0.3,1.7-0.1,2.6l-1.8-1.1c0.1-0.4,0.1-0.8-0.1-1.2
			c-0.2-0.4-0.5-0.7-1-1c-0.5-0.3-1-0.4-1.6-0.3s-1,0.5-1.4,1.1l-0.7,1.1c0.4-0.2,0.9-0.3,1.5-0.2c0.5,0,1.1,0.2,1.6,0.5
			c0.6,0.4,1.1,0.9,1.4,1.5c0.3,0.6,0.4,1.3,0.4,2c-0.1,0.7-0.3,1.5-0.8,2.2c-0.4,0.7-1,1.3-1.6,1.7c-0.6,0.4-1.3,0.6-2,0.6
			c-0.7,0-1.3-0.2-1.9-0.6C156.2,391.3,155.8,390.9,155.5,390.4z M156.2,387.8c0,0.4,0.1,0.8,0.2,1.2c0.2,0.3,0.4,0.6,0.8,0.8
			c0.3,0.2,0.7,0.3,1.1,0.3c0.4,0,0.8-0.1,1.1-0.3s0.7-0.5,1-1c0.3-0.4,0.4-0.9,0.4-1.3c0-0.4-0.1-0.8-0.2-1.2
			c-0.2-0.3-0.4-0.6-0.8-0.8c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4,0-0.8,0.1-1.1,0.3c-0.4,0.2-0.7,0.5-1,1
			C156.4,386.9,156.2,387.3,156.2,387.8z"
          />
          <path d="M144.2,383l11.3-7.1l1.8,1.3l-3.9,2.4l-1.9,8.6l-1.9-1.4l1.6-6l-5.2,3.5L144.2,383z" />
        </g>
      </g>
      <g id="regulation">
        <g>
          <path
            id="path-12"
            d="M244.8,244.9l71.9,135.5
			c-11.4,6.1-22.3,10.3-34.9,13.4L244.8,244.9L244.8,244.9z"
            data-active={active === 12}
            onClick={() => onClick(12)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(12)}
          />
          <path
            className="filler"
            d="M281.5,394.5l-0.1-0.5l-38.1-152.9l74.1,139.5l-0.4,0.2c-11.5,6.1-22.3,10.3-35,13.5L281.5,394.5z
			 M246.3,248.8l36,144.5c12.2-3.1,22.7-7.1,33.8-13L246.3,248.8z"
          />
        </g>
        <g>
          <path
            id="path-11"
            d="M244.8,244.9l102.5,114
			c-9.6,8.7-19.2,15.4-30.6,21.5L244.8,244.9L244.8,244.9z"
            data-active={active === 11}
            onClick={() => onClick(11)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(11)}
          />
          <path
            className="filler"
            d="M316.6,381.1l-0.2-0.4l-72-135.6v-1.4l0.9,1L348.1,359l-0.4,0.3c-9.7,8.8-19.2,15.4-30.7,21.5
			L316.6,381.1z M247.2,248.3L317,379.8c11.1-5.9,20.3-12.4,29.7-20.8L247.2,248.3z"
          />
        </g>
        <g>
          <path
            id="path-10"
            d="M244.8,244.9l127,85.8
			c-7.2,10.8-14.9,19.6-24.5,28.2L244.8,244.9z"
            data-active={active === 10}
            onClick={() => onClick(10)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(10)}
          />
          <path
            className="filler"
            d="M347.3,359.7l-0.3-0.4L241.7,242.3l130.8,88.4l-0.3,0.4c-7.3,10.8-14.9,19.6-24.6,28.3L347.3,359.7
			z M247.9,247.6l99.5,110.6c9.3-8.5,16.7-17,23.8-27.4L247.9,247.6z"
          />
        </g>
        <g>
          <path
            id="path-9"
            d="M244.8,244.9l144,52.5
			c-4.4,12.2-9.7,22.6-17,33.3L244.8,244.9L244.8,244.9z"
            data-active={active === 9}
            onClick={() => onClick(9)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(9)}
          />
          <path
            className="filler"
            d="M372,331.4l-130.8-88.4l148.3,54l-0.2,0.5c-4.5,12.3-9.7,22.6-17,33.4L372,331.4z M248.5,246.8
			l123.2,83.3c7-10.5,12.1-20.5,16.4-32.3L248.5,246.8z"
          />
        </g>
        <path
          id="_x39_"
          d="M359.9,303.5c-0.4,0.2-0.8,0.6-1.1,1.1c-0.4,0.7-0.4,1.3,0,1.9c0.4,0.6,1.2,1.2,2.5,1.9
		c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.2-1,0.5-1.5c0.3-0.6,0.7-1.1,1.3-1.5c0.5-0.4,1.1-0.6,1.8-0.6c0.7,0,1.4,0.1,2.1,0.5
		c1.1,0.6,1.7,1.3,2.1,2.3c0.3,1,0.2,2-0.4,3.1c-0.7,1.3-1.6,2-2.8,2.1c-1.2,0.1-2.7-0.3-4.5-1.3c-1.3-0.6-2.2-1.3-2.9-1.9
		c-0.7-0.6-1.1-1.3-1.2-2c-0.1-0.7,0-1.6,0.5-2.5c0.5-1,1.2-1.7,2.1-2c0.8-0.3,1.7-0.2,2.5,0.1l-0.8,1.5
		C360.8,303.3,360.3,303.3,359.9,303.5L359.9,303.5z M362.7,308.2c0.2,0.5,0.6,0.9,1.2,1.3c0.7,0.4,1.3,0.4,1.8,0.3
		c0.6-0.2,1-0.6,1.3-1.2c0.3-0.6,0.4-1.2,0.2-1.8c-0.2-0.6-0.6-1-1.2-1.3c-0.6-0.3-1.2-0.4-1.7-0.2c-0.6,0.1-1,0.6-1.4,1.3
		C362.5,307.2,362.5,307.7,362.7,308.2L362.7,308.2z"
        />
        <g id="_x31_0">
          <path d="M353.3,329.2l1.3,1.1l-2.1,2.7l-9.3-7.5l1.2-1.5l8,6.4L353.3,329.2L353.3,329.2z" />
          <path
            d="M348.9,335.2c0.4,1.2,0,2.4-1,3.5c-1.1,1.2-2.2,1.6-3.4,1.4c-1.2-0.2-2.5-1-3.9-2.3
			c-1.4-1.3-2.3-2.5-2.7-3.7c-0.4-1.2,0-2.4,1-3.5c1.1-1.2,2.2-1.6,3.4-1.4c1.2,0.3,2.5,1,4,2.3C347.7,332.7,348.5,334,348.9,335.2
			L348.9,335.2z M343.5,337.8c0.5,0.3,1.1,0.5,1.6,0.5s1-0.3,1.5-0.8c0.5-0.5,0.7-1,0.6-1.5c-0.1-0.5-0.3-1-0.6-1.5
			c-0.4-0.5-0.9-1-1.6-1.6c-0.7-0.6-1.3-1.1-1.8-1.4c-0.5-0.3-1.1-0.5-1.6-0.5c-0.5,0-1,0.3-1.5,0.8c-0.5,0.5-0.7,1-0.6,1.5
			c0,0.5,0.3,1,0.6,1.5c0.4,0.5,0.9,1.1,1.6,1.7C342.4,337,343,337.5,343.5,337.8L343.5,337.8z"
          />
        </g>
        <g id="_x31_1">
          <path d="M328.5,354l1,1.4l-2.7,2l-7.1-9.6l1.5-1.1l6.1,8.2L328.5,354L328.5,354z" />
          <path d="M323.6,357.6l1,1.4l-2.8,1.9L315,351l1.6-1.1l5.8,8.5L323.6,357.6L323.6,357.6z" />
        </g>
        <g id="_x31_2">
          <path d="M301.9,370l0.7,1.6l-3.1,1.4l-4.8-11l1.7-0.8l4.1,9.4L301.9,370L301.9,370z" />
          <path
            d="M292.4,365.7c-0.7,1.2-1.2,2.2-1.6,3c-0.4,0.8-0.6,1.5-0.8,2.2c-0.2,0.7-0.1,1.4,0.1,2
			c0.2,0.6,0.6,1,1,1.3c0.4,0.2,0.9,0.2,1.6,0c0.6-0.2,1-0.6,1.2-1.1c0.2-0.5,0.2-1.1,0-1.7l1.7-0.6c0.4,1.2,0.4,2.2-0.1,3.1
			c-0.4,0.9-1.2,1.5-2.2,1.9c-1.1,0.4-2.1,0.4-3,0.1c-0.9-0.4-1.5-1.1-1.9-2.1c-0.3-0.7-0.4-1.5-0.2-2.3c0.1-0.8,0.3-1.6,0.7-2.3
			c0.3-0.7,0.7-1.6,1.3-2.6l0.5-0.9l-4.9,1.8l-0.5-1.5l7.5-2.8l0.5,1.3L292.4,365.7L292.4,365.7z"
          />
        </g>
        <path
          className="spacer"
          d="M280.4,396.3L242,241.8l149.4,54.5l-0.7,1.9c-4.5,12.4-9.8,22.8-17.2,33.8
		c-7.4,10.9-15,19.8-24.8,28.6c-9.8,8.8-19.3,15.5-31,21.7c-11.7,6.2-22.6,10.4-35.3,13.6L280.4,396.3z M247.7,248.1l35.7,143.3
		c11.6-3,21.7-7,32.5-12.7c11.4-6.1,20.7-12.6,30.2-21.2c9.6-8.6,17-17.2,24.2-27.9c6.8-10.1,11.8-19.8,16-31L247.7,248.1z"
        />
        <g id="icon-regulation">
          <rect x="373.9" y="388.5" width="2" height="15.7" />
          <path d="M386.7,407.1h-9.8v-2h9.8c0.5,0,0.9-0.4,0.9-0.9h2C389.6,405.8,388.3,407.1,386.7,407.1z" />
          <path d="M376.8,407.1c-1.6,0-2.9-1.3-2.9-2.9h2c0,0.5,0.4,0.9,0.9,0.9V407.1z" />
          <rect x="387.6" y="388.5" width="2" height="2.5" />
          <rect x="387.6" y="401.7" width="2" height="2.5" />
          <path d="M389.6,388.7h-2c0-0.5-0.4-0.9-0.9-0.9v-2C388.3,385.8,389.6,387.1,389.6,388.7z" />
          <path d="M375.9,388.7h-2c0-1.6,1.3-2.9,2.9-2.9h9.8v2h-9.8C376.3,387.8,375.9,388.2,375.9,388.7z" />
          <path
            d="M383.1,400.7l-1.5-1.4c0.2-0.3,6.2-6.6,14.6-10.4l2.3-1.1l-2.4,5.8l1.4,1.7l-4.2,1.5l1.2,1.5
			l-1.9,0.2c-3.3,0.3-7.1,0.6-8.1,0.8C383.6,400.2,383.1,400.7,383.1,400.7z M394.7,391.9c-3,1.6-5.6,3.5-7.5,5.1
			c0.9-0.1,2-0.2,3.3-0.3l-0.6-0.7l4.3-1.5l-0.4-0.4L394.7,391.9z"
          />
        </g>
        <g className="label" data-active={isInRange(active, 9, 12)}>
          <path
            d="M375.8,343.4l4.7,0.6l0.6-0.8l-3.3-2.4l1.3-1.7l8.5,6.3l-2.3,3.2c-0.5,0.7-1,1.1-1.6,1.4
			c-0.6,0.3-1.1,0.4-1.7,0.4c-0.6-0.1-1.1-0.3-1.6-0.6c-0.6-0.4-0.9-0.9-1.2-1.6c-0.2-0.7-0.2-1.4,0.1-2.1l-4.9-0.5L375.8,343.4z
			 M382.3,344.1l-1,1.4c-0.3,0.5-0.5,0.9-0.4,1.3c0.1,0.4,0.3,0.7,0.7,1c0.4,0.3,0.8,0.4,1.2,0.3c0.4-0.1,0.7-0.3,1.1-0.8l1-1.4
			L382.3,344.1z"
          />
          <path
            d="M371.2,354.8l3.9-4.7c-0.5-0.3-1-0.5-1.5-0.4c-0.5,0.1-0.9,0.3-1.3,0.7c-0.5,0.6-0.6,1.3-0.3,1.9
			l-1.5,1.8c-0.5-0.7-0.7-1.5-0.6-2.3c0-0.9,0.4-1.7,1-2.4c0.5-0.6,1.1-1.1,1.8-1.3c0.7-0.3,1.4-0.3,2.1-0.2c0.7,0.1,1.4,0.5,2.1,1
			c0.7,0.6,1.1,1.2,1.4,1.9c0.3,0.7,0.4,1.4,0.2,2.1s-0.5,1.4-1,2c-0.5,0.6-1.1,1.1-1.8,1.3c-0.7,0.3-1.4,0.3-2.1,0.2
			c-0.7-0.1-1.4-0.5-2-1C371.6,355.1,371.4,355,371.2,354.8z M373.7,354c0.4,0.3,0.9,0.5,1.4,0.4c0.5-0.1,0.9-0.3,1.3-0.8
			c0.3-0.4,0.5-0.8,0.5-1.3c0-0.5-0.2-0.9-0.6-1.4L373.7,354z"
          />
          <path
            d="M370.2,362.6c-0.5,0.2-1,0.2-1.5,0.2l0.9,0.8l-1.5,1.6l-6.2-5.7c-0.6-0.5-1-1.1-1.2-1.8
			c-0.2-0.6-0.3-1.3-0.1-2c0.2-0.7,0.5-1.4,1.2-2c0.8-0.9,1.7-1.4,2.6-1.6c0.9-0.2,1.8,0,2.5,0.6l-1.4,1.5c-0.4-0.2-0.7-0.2-1.2-0.1
			c-0.4,0.1-0.8,0.4-1.2,0.8c-0.4,0.5-0.6,0.9-0.6,1.5c0,0.5,0.3,1.1,0.8,1.6l1,0.9c-0.1-0.5-0.1-1,0-1.5c0.1-0.5,0.4-1,0.8-1.5
			c0.5-0.5,1.1-0.9,1.7-1c0.7-0.2,1.4-0.2,2.1,0c0.7,0.2,1.4,0.6,2,1.2c0.6,0.6,1.1,1.2,1.3,1.9c0.2,0.7,0.3,1.4,0.2,2
			c-0.1,0.7-0.4,1.3-0.9,1.8C371.2,362.1,370.7,362.5,370.2,362.6z M367.7,361.4c0.4,0.1,0.8,0.1,1.2,0c0.4-0.1,0.7-0.3,1-0.6
			c0.3-0.3,0.4-0.6,0.5-1c0.1-0.4,0.1-0.8-0.1-1.2c-0.1-0.4-0.4-0.8-0.7-1.1c-0.4-0.3-0.8-0.6-1.2-0.7c-0.4-0.1-0.8-0.1-1.2,0
			c-0.4,0.1-0.7,0.3-1,0.6c-0.3,0.3-0.4,0.6-0.5,1c-0.1,0.4-0.1,0.8,0.1,1.2c0.1,0.4,0.4,0.8,0.8,1.1
			C366.9,361.1,367.3,361.3,367.7,361.4z"
          />
          <path
            d="M360.9,372.3l-5.8-6.1l1.5-1.5l0.7,0.8c-0.1-0.5,0-0.9,0.2-1.4s0.4-0.9,0.8-1.2
			c0.5-0.5,1-0.8,1.5-0.9c0.6-0.1,1.1-0.1,1.7,0.1c0.6,0.2,1.1,0.6,1.6,1.1l3.4,3.6l-1.5,1.5l-3.2-3.3c-0.5-0.5-0.9-0.7-1.4-0.8
			c-0.5,0-0.9,0.2-1.4,0.6c-0.4,0.4-0.6,0.8-0.6,1.3c0,0.5,0.2,1,0.7,1.5l3.2,3.3L360.9,372.3z"
          />
          <path d="M359.5,377.2l-7.4-8.4l1.6-1.4l7.4,8.4L359.5,377.2z" />
          <path
            d="M354.8,375c0.1,0.7,0.1,1.4-0.1,2c-0.2,0.6-0.6,1.2-1.2,1.6c-0.5,0.4-1,0.6-1.5,0.7
			c-0.5,0.1-1,0.1-1.5,0l0.7,0.9l-1.7,1.3l-5.3-6.5l1.7-1.3l0.8,1c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.6-0.9,1.1-1.3
			c0.6-0.4,1.2-0.7,1.8-0.8s1.4,0,2,0.3c0.7,0.3,1.3,0.8,1.8,1.5C354.3,373.6,354.7,374.3,354.8,375z M349.7,377.9
			c0.4,0.2,0.8,0.2,1.2,0.1s0.7-0.2,1-0.5c0.3-0.2,0.5-0.5,0.7-0.9c0.1-0.4,0.2-0.7,0.1-1.2s-0.3-0.8-0.6-1.2
			c-0.3-0.4-0.7-0.7-1.1-0.8c-0.4-0.2-0.8-0.2-1.2-0.2c-0.4,0.1-0.7,0.2-1,0.4c-0.3,0.2-0.5,0.6-0.7,0.9c-0.1,0.4-0.2,0.8-0.1,1.2
			c0.1,0.4,0.3,0.8,0.6,1.2C349,377.5,349.3,377.8,349.7,377.9z"
          />
          <path
            d="M344.8,383l-2.4-3.3c-0.2-0.2-0.3-0.4-0.5-0.4c-0.2,0-0.4,0.1-0.7,0.3l-0.8,0.6l-1.1-1.4l1.1-0.8
			c1.4-1.1,2.7-0.9,3.7,0.5l2.4,3.3l0.8-0.6l1,1.4l-0.8,0.6l1.2,1.7l-1.7,1.3l-1.2-1.7l-1.5,1.1l-1-1.4L344.8,383z"
          />
          <path
            d="M341.3,387.6l-4.7-6.9l1.8-1.2l4.7,6.9L341.3,387.6z M343.7,387.6c0.3,0.1,0.6,0.2,0.8,0.5
			c0.2,0.3,0.3,0.6,0.2,0.9c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.3-1,0.2c-0.3-0.1-0.6-0.2-0.8-0.5c-0.2-0.3-0.3-0.6-0.2-0.9
			c0.1-0.3,0.3-0.6,0.6-0.8C343,387.6,343.3,387.6,343.7,387.6z"
          />
          <path
            d="M334,382.9c0.7,0,1.4,0.1,2.1,0.5c0.7,0.4,1.2,0.9,1.7,1.6c0.5,0.7,0.7,1.5,0.7,2.2
			c0,0.8-0.1,1.5-0.5,2.1c-0.4,0.6-0.9,1.2-1.6,1.6c-0.7,0.4-1.4,0.7-2.1,0.7s-1.5-0.1-2.1-0.5c-0.7-0.4-1.2-0.9-1.7-1.6
			c-0.5-0.7-0.7-1.5-0.7-2.2c0-0.8,0.2-1.5,0.5-2.1c0.4-0.7,0.9-1.2,1.6-1.6C332.5,383.1,333.2,382.9,334,382.9z M332,386
			c-0.2,0.3-0.3,0.7-0.2,1.1s0.2,0.9,0.5,1.3c0.4,0.7,0.9,1.1,1.5,1.2c0.6,0.1,1.1,0.1,1.6-0.3c0.5-0.3,0.8-0.8,1-1.4
			c0.1-0.6,0-1.2-0.5-1.9c-0.4-0.7-0.9-1.1-1.5-1.2c-0.6-0.2-1.1-0.1-1.6,0.3C332.5,385.3,332.2,385.6,332,386z"
          />
          <path
            d="M324.5,396.7c-0.8-0.3-1.5-0.9-2.1-1.9l-2.4-4.3l1.9-1l2.2,4.1c0.3,0.6,0.7,1,1.2,1.1
			c0.5,0.2,0.9,0.1,1.5-0.2c0.5-0.3,0.8-0.7,1-1.1c0.1-0.5,0-1-0.3-1.6l-2.2-4.1l1.9-1l4,7.4l-1.9,1l-0.5-0.9
			c-0.1,0.5-0.3,0.9-0.5,1.3c-0.3,0.4-0.7,0.7-1.1,1C326.2,396.8,325.3,396.9,324.5,396.7z"
          />
        </g>
      </g>
      <g id="customer-interest">
        <g>
          <path
            id="path-8"
            d="M244.8,244.9l152.4,16
			c-1.4,12.9-4,24.3-8.4,36.4L244.8,244.9L244.8,244.9z"
            data-active={active === 8}
            onClick={() => onClick(8)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(8)}
          />
          <path
            className="filler"
            d="M389.1,298.1l-0.5-0.2L242,244.4l2.9,0l152.9,16.1l-0.1,0.5c-1.4,13-4,24.3-8.4,36.6L389.1,298.1z
			 M248.8,245.9l139.7,50.9c4.3-11.9,6.8-22.8,8.2-35.4L248.8,245.9z"
          />
        </g>
        <g>
          <path
            id="path-7"
            d="M244.8,244.9l152.1-18.7
			c1.6,12.9,1.6,21.8,0.3,34.7L244.8,244.9L244.8,244.9z"
            data-active={active === 7}
            onClick={() => onClick(7)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(7)}
          />
          <path
            className="filler"
            d="M397.6,261.5l-0.5-0.1L240.4,245l156.9-19.3l0.1,0.5c1.6,12.8,1.7,21.9,0.3,34.9L397.6,261.5z
			 M249.2,244.9l147.5,15.5c1.3-12.4,1.2-21.3-0.3-33.6L249.2,244.9z"
          />
        </g>
        <g>
          <path
            id="path-6"
            d="M244.8,244.9l143-55
			c4.6,12.1,7.5,23.4,9,36.3L244.8,244.9L244.8,244.9z"
            data-active={active === 6}
            onClick={() => onClick(6)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(6)}
          />
          <path
            className="filler"
            d="M240.9,245.9l147.3-56.6l0.2,0.5c4.7,12.2,7.5,23.4,9.1,36.4l0.1,0.5L240.9,245.9z M387.6,190.6
			L248.8,244l147.5-18.1C394.8,213.3,392.1,202.4,387.6,190.6z"
          />
        </g>
        <g>
          <path
            id="path-5"
            d="M244.8,244.9l125.5-88
			c7.4,10.6,12.9,20.9,17.5,33L244.8,244.9L244.8,244.9z"
            data-active={active === 5}
            onClick={() => onClick(5)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(5)}
          />
          <path
            className="filler"
            d="M241.2,246.9l129.2-90.7l0.3,0.4c7.5,10.7,12.9,20.9,17.6,33.1l0.2,0.5L241.2,246.9z M370.2,157.6
			L248.5,243l138.8-53.4C382.7,177.9,377.4,168,370.2,157.6z"
          />
        </g>
        <g>
          <path
            id="path-4"
            d="M244.8,244.9l100.5-115.8
			c9.8,8.5,17.6,17.2,25,27.8L244.8,244.9L244.8,244.9z"
            data-active={active === 4}
            onClick={() => onClick(4)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(4)}
          />
          <path
            className="filler"
            d="M245,245.4h-1.3l0.7-0.8l100.8-116.2l0.4,0.3c9.8,8.5,17.6,17.2,25.1,27.9l0.3,0.4l-0.4,0.3
			L245,245.4z M345.4,129.8l-97.5,112.4l121.8-85.4C362.4,146.5,354.9,138.1,345.4,129.8z"
          />
        </g>
        <g>
          <path
            id="path-3"
            d="M244.8,244.9l69.6-136.7
			c11.5,5.9,21.2,12.4,31,20.9L244.8,244.9z"
            data-active={active === 3}
            onClick={() => onClick(3)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(3)}
          />
          <path
            className="filler"
            d="M244,246.1L314.3,108l0.2,0.1c11.6,5.9,21.2,12.4,31,20.9l0.1,0.1l-0.1,0.1L244,246.1z
			 M314.5,108.4l-68.8,135.3l99.5-114.6C335.4,120.7,326,114.3,314.5,108.4z"
          />
        </g>
        <g>
          <path
            id="path-2"
            d="M244.8,244.9l34.5-149.5
			c12.6,2.9,23.6,6.9,35.1,12.8L244.8,244.9L244.8,244.9z"
            data-active={active === 2}
            onClick={() => onClick(2)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(2)}
          />
          <path
            className="filler"
            d="M243.4,248.8l35.5-154l0.5,0.1c12.7,2.9,23.6,6.9,35.2,12.8l0.4,0.2l-0.2,0.4L243.4,248.8z
			 M279.7,96l-33.4,145.1l67.5-132.7C302.5,102.7,291.9,98.9,279.7,96z"
          />
        </g>
        <g>
          <path
            id="path-1"
            d="M244.8,244.9V91.5
			c12.9,0,21.8,1,34.5,3.9L244.8,244.9L244.8,244.9z"
            data-active={active === 1}
            onClick={() => onClick(1)}
            data-tooltip-id="radar-tooltip"
            onMouseEnter={() => onMouseEnter(1)}
          />
          <path
            className="filler"
            d="M244.3,249.3V91h0.5c12.9,0,22,1,34.6,3.9l0.5,0.1L244.3,249.3z M245.3,92v148.6l33.4-144.8
			C266.6,93,257.7,92,245.3,92z"
          />
        </g>
        <path
          id="_x31_"
          d="M259.2,108.2l0.2-1.7l3.4,0.4l-1.4,11.9l-1.9-0.2l1.2-10.2L259.2,108.2z"
        />
        <path
          id="_x32_"
          d="M286.7,122.1c1.3-0.5,2.3-0.9,3.1-1.3c0.8-0.3,1.5-0.7,2-1.2c0.6-0.5,1-1,1.2-1.6
		c0.2-0.6,0.3-1.2,0.1-1.6c-0.2-0.5-0.6-0.8-1.2-1c-0.6-0.2-1.1-0.2-1.6,0.1c-0.5,0.3-0.8,0.7-1.1,1.4l-1.7-0.6
		c0.5-1.2,1.1-1.9,2-2.3c0.9-0.4,1.9-0.4,2.9,0c1.1,0.4,1.9,1,2.3,1.9c0.4,0.8,0.4,1.8,0,2.8c-0.3,0.7-0.7,1.4-1.3,1.9
		c-0.6,0.6-1.3,1-2,1.3c-0.7,0.4-1.6,0.7-2.7,1.2l-0.9,0.4l4.9,1.8l-0.5,1.5l-7.5-2.7l0.5-1.3L286.7,122.1L286.7,122.1z"
        />
        <path
          id="_x33_"
          d="M319.2,128c0.9-0.1,1.8,0.2,2.8,0.8c0.6,0.4,1.1,0.9,1.4,1.4s0.5,1.1,0.4,1.6
		c0,0.6-0.2,1.1-0.5,1.6c-0.4,0.6-0.8,0.9-1.4,1.1c-0.6,0.2-1.1,0.2-1.6,0.1l0,0.1c0.4,0.5,0.6,1.1,0.7,1.7c0,0.6-0.2,1.3-0.6,2
		c-0.4,0.5-0.8,0.9-1.3,1.2c-0.5,0.3-1.1,0.3-1.7,0.3c-0.6-0.1-1.3-0.4-2-0.8c-1-0.6-1.6-1.4-1.9-2.4c-0.3-0.9-0.2-1.9,0.4-2.9
		l1.5,1c-0.3,0.5-0.4,1-0.2,1.6c0.1,0.5,0.5,1,1.1,1.4c0.5,0.4,1.1,0.5,1.6,0.4c0.5-0.1,0.9-0.4,1.2-0.9c0.4-0.6,0.5-1.2,0.3-1.8
		c-0.2-0.5-0.8-1.1-1.6-1.7l-0.4-0.2l0.9-1.3l0.4,0.2c0.7,0.5,1.4,0.7,1.9,0.8c0.5,0,1-0.2,1.3-0.7c0.3-0.4,0.4-0.9,0.3-1.3
		s-0.4-0.8-0.9-1.2c-0.5-0.3-1-0.5-1.4-0.4c-0.5,0.1-0.8,0.3-1.1,0.6l-1.5-1C317.6,128.5,318.3,128.1,319.2,128L319.2,128z"
        />
        <path
          id="_x34_"
          d="M336.9,153.6l1-1l9.5-1.3l1.5,1.7l-5.6,5.2l1,1.1l-1.2,1.1l-1-1.1l-1.8,1.7l-1.2-1.4
		l1.8-1.7L336.9,153.6L336.9,153.6z M346.4,153l-6.9,1.1l2.6,2.8L346.4,153L346.4,153z"
        />
        <path
          id="_x35_"
          d="M367.8,183.5l-2.6-4.9l-2.9,1.5c0.4,0.1,0.8,0.2,1.2,0.5c0.4,0.3,0.7,0.7,1,1.1
		c0.4,0.8,0.6,1.6,0.5,2.3c-0.1,0.7-0.3,1.3-0.7,1.8c-0.4,0.5-0.9,0.9-1.5,1.2c-0.7,0.4-1.4,0.6-2.1,0.6c-0.7,0-1.4-0.2-2-0.5
		c-0.6-0.4-1.1-1-1.5-1.8c-0.6-1.1-0.7-2-0.6-3c0.2-0.9,0.7-1.7,1.5-2.2l0.9,1.6c-0.4,0.4-0.6,0.8-0.7,1.3c-0.1,0.5,0,1,0.3,1.6
		c0.4,0.7,0.8,1.1,1.4,1.2c0.6,0.1,1.2,0,1.9-0.4c0.7-0.4,1.1-0.8,1.3-1.4c0.2-0.6,0.1-1.2-0.3-1.8c-0.3-0.5-0.6-0.8-1-1
		c-0.4-0.2-0.8-0.3-1.3-0.2l-0.8-1.6l6.1-3.2l3.4,6.4L367.8,183.5L367.8,183.5z"
        />
        <path
          id="_x36_"
          d="M378.4,212.6c0.2-0.4,0.2-0.8,0-1.4c-0.2-0.8-0.7-1.4-1.4-1.6c-0.7-0.3-1.9-0.2-3.4,0.2
		c0.5,0.2,1,0.5,1.4,0.9c0.4,0.5,0.7,1,0.8,1.6c0.2,0.7,0.2,1.4,0,2c-0.2,0.6-0.5,1.1-1,1.6c-0.5,0.5-1.1,0.8-1.9,1
		c-0.7,0.2-1.4,0.2-2.1,0.1c-0.6-0.1-1.2-0.5-1.7-0.9c-0.5-0.5-0.8-1.1-1-1.9c-0.3-1.1-0.3-2,0.1-2.8c0.3-0.7,0.9-1.4,1.7-1.8
		s1.9-0.9,3.2-1.2c3.9-1,6.2-0.1,6.9,2.6c0.3,1.1,0.2,2-0.2,2.7c-0.4,0.7-1,1.3-1.8,1.6l-0.4-1.7C377.9,213.3,378.2,213,378.4,212.6
		L378.4,212.6z M373.2,210.8c-0.5-0.4-1.1-0.4-1.8-0.3c-0.7,0.2-1.3,0.5-1.6,1.1c-0.3,0.5-0.4,1.2-0.2,1.9c0.2,0.7,0.5,1.1,1,1.4
		c0.5,0.3,1.1,0.3,1.8,0.2c0.7-0.2,1.2-0.5,1.6-1c0.3-0.5,0.4-1.1,0.2-1.8C374,211.7,373.7,211.2,373.2,210.8L373.2,210.8z"
        />
        <path
          id="_x37_"
          d="M382.4,247.8l-10.5-4.5v-1.9l10.3,4.5l0-6.1h1.6l0.1,7.9L382.4,247.8L382.4,247.8z"
        />
        <path
          id="_x38_"
          d="M378.3,271.2c0.6,0.1,1.1,0.4,1.5,0.8c0.4,0.4,0.7,0.9,0.8,1.6c0.2,0.6,0.1,1.4-0.1,2.2
		c-0.2,0.8-0.5,1.5-0.9,2c-0.4,0.5-0.9,0.9-1.4,1c-0.5,0.2-1.1,0.2-1.7,0.1c-0.6-0.1-1.1-0.4-1.5-0.8c-0.4-0.4-0.6-0.9-0.8-1.4
		c-0.4,0.6-0.8,1-1.4,1.2c-0.6,0.2-1.2,0.3-1.9,0.1c-0.7-0.2-1.3-0.5-1.7-0.9c-0.5-0.5-0.8-1.1-0.9-1.8c-0.1-0.7-0.1-1.4,0.1-2.2
		c0.2-0.8,0.5-1.5,0.9-2c0.4-0.6,0.9-1,1.6-1.2c0.6-0.2,1.3-0.3,2-0.1c0.7,0.2,1.3,0.5,1.7,0.9c0.4,0.5,0.7,1,0.8,1.7
		C376.1,271.3,377.1,270.9,378.3,271.2L378.3,271.2z M373.9,272.4c-0.2-0.5-0.7-0.9-1.3-1c-0.6-0.1-1.1,0-1.6,0.3
		c-0.5,0.3-0.8,0.9-1,1.6c-0.2,0.7-0.1,1.3,0.2,1.9c0.3,0.5,0.7,0.8,1.3,1c0.6,0.1,1.2,0,1.6-0.3c0.5-0.4,0.7-0.9,0.9-1.6
		C374.2,273.6,374.2,272.9,373.9,272.4L373.9,272.4z M378.3,276.8c0.4-0.3,0.7-0.8,0.8-1.4c0.1-0.6,0.1-1.2-0.1-1.6
		c-0.2-0.4-0.7-0.7-1.3-0.9c-0.5-0.1-1,0-1.4,0.3c-0.4,0.3-0.7,0.8-0.8,1.4c-0.1,0.6-0.1,1.1,0.2,1.6c0.3,0.5,0.6,0.8,1.2,0.9
		C377.3,277.2,377.8,277.1,378.3,276.8L378.3,276.8z"
        />
        <path
          className="spacer"
          d="M390,300l-147.2-53.6V89.5h2c13,0,22.2,1,34.9,4c12.8,3,23.8,7,35.6,13c11.8,6,21.4,12.5,31.4,21.2
		c9.9,8.6,17.7,17.3,25.3,28.2c7.6,10.8,13,21.2,17.8,33.5c4.7,12.3,7.6,23.7,9.2,36.8c1.6,13,1.7,22.2,0.3,35.2
		c-1.4,13.1-4,24.5-8.5,36.9L390,300z M246.8,243.6l140.8,51.3c4-11.4,6.4-22,7.6-34.1c1.3-12.7,1.3-21.7-0.3-34.3
		c-1.6-12.8-4.3-23.8-8.9-35.8c-4.6-12-9.9-22-17.3-32.6c-7.4-10.6-15-19-24.7-27.4c-9.7-8.4-19.1-14.8-30.6-20.7
		c-11.5-5.9-22.2-9.8-34.6-12.6c-11.8-2.7-20.4-3.8-32-3.9V243.6z"
        />
        <g id="icon-customer-intrest">
          <path
            d="M414.3,139h-5.1c-2,0-3.6-1.6-3.6-3.6v-1.9h2v1.9c0,0.9,0.7,1.6,1.6,1.6h3.4l0.6-4.3l2-0.9
			l-0.9-2.2c-0.4-0.9-0.6-1.9-0.6-2.9c0-0.3,0-0.6,0-1c-0.3-2.7-2-5.1-4.4-6.3c-1.9-0.9-4-1-6-0.3c-2,0.7-3.5,2.1-4.4,4
			c-1.2,2.5-1,5.5,0.6,7.8c0.6,0.9,0.9,2,0.9,3.1v4.8h-2v-4.8c0-0.7-0.2-1.4-0.6-1.9c-2-2.9-2.3-6.6-0.8-9.8c1.1-2.4,3.1-4.2,5.6-5
			c2.5-0.9,5.1-0.7,7.5,0.4c3.1,1.5,5.2,4.5,5.6,7.9c0,0.4,0.1,0.8,0,1.2c0,0.7,0.1,1.4,0.4,2l1.7,4l-2.8,1.2L414.3,139z"
          />
        </g>
        <g className="label" data-active={isInRange(active, 1, 8)}>
          <path
            d="M335.1,100.7c0.8-0.4,1.7-0.6,2.7-0.6c0.9,0.1,1.8,0.4,2.7,0.9c1,0.6,1.7,1.5,2.1,2.5
			c0.4,1,0.5,2,0.2,3.1l-2-1.3c0.1-0.6,0-1.1-0.2-1.5c-0.2-0.5-0.6-0.8-1.1-1.1c-0.5-0.3-1.1-0.5-1.6-0.5c-0.6,0-1.1,0.1-1.6,0.4
			s-1,0.7-1.3,1.3c-0.4,0.6-0.6,1.2-0.7,1.8c-0.1,0.6,0,1.1,0.3,1.6c0.2,0.5,0.6,0.9,1.1,1.3c0.5,0.3,1,0.5,1.5,0.5
			c0.5,0,1-0.1,1.5-0.4l2,1.3c-0.9,0.7-1.9,1.1-2.9,1.1c-1.1,0-2.1-0.3-3.1-0.9c-0.8-0.6-1.5-1.2-1.9-2.1c-0.4-0.8-0.6-1.7-0.6-2.7
			c0.1-0.9,0.4-1.8,0.9-2.7C333.5,101.8,334.2,101.1,335.1,100.7z"
          />
          <path
            d="M351.3,111.6l-5,6.7l-1.7-1.3l0.6-0.8c-0.4,0.1-0.9,0.1-1.4,0c-0.5-0.1-0.9-0.3-1.3-0.6
			c-0.5-0.4-0.9-0.9-1.1-1.4c-0.2-0.5-0.3-1.1-0.2-1.7c0.1-0.6,0.4-1.2,0.8-1.8l2.9-3.9l1.7,1.3l-2.8,3.7c-0.4,0.5-0.6,1-0.5,1.5
			c0.1,0.5,0.3,0.9,0.8,1.2c0.5,0.4,0.9,0.5,1.4,0.4s0.9-0.4,1.3-0.9l2.8-3.7L351.3,111.6z"
          />
          <path
            d="M348.8,120.2c-0.3-0.5-0.4-1.1-0.3-1.6c0-0.5,0.2-1,0.5-1.4l1.6,1.4c-0.2,0.3-0.2,0.6-0.1,0.9
			c0.1,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.6,0.4,0.9,0.4c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.2-0.5,0.1-0.7c-0.1-0.3-0.4-0.7-0.7-1.2
			c-0.4-0.5-0.7-1-0.9-1.3c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.4,0.2-0.9,0.5-1.3c0.3-0.4,0.7-0.6,1.1-0.7c0.5-0.1,0.9-0.1,1.5,0
			c0.5,0.1,1,0.4,1.6,0.9c0.8,0.6,1.2,1.3,1.4,2.1c0.1,0.8,0,1.5-0.5,2.2l-1.6-1.3c0.2-0.3,0.3-0.6,0.2-0.9
			c-0.1-0.3-0.3-0.6-0.6-0.9c-0.3-0.2-0.6-0.4-0.8-0.4c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.2,0.5-0.1,0.8s0.4,0.7,0.7,1.2
			c0.4,0.5,0.7,0.9,0.8,1.3c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.2,0.9-0.5,1.3c-0.3,0.4-0.7,0.6-1.1,0.7c-0.5,0.1-0.9,0.1-1.5,0
			c-0.5-0.2-1-0.4-1.6-0.9C349.5,121.2,349.1,120.7,348.8,120.2z"
          />
          <path
            d="M360,121.4l-2.7,3c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.4,0.4,0.6l0.7,0.7l-1.2,1.3l-1-0.9
			c-1.3-1.2-1.4-2.4-0.2-3.7l2.7-3l-0.7-0.7l1.2-1.3l0.7,0.7l1.4-1.5l1.6,1.4l-1.4,1.5l1.4,1.3l-1.2,1.3L360,121.4z"
          />
          <path
            d="M359.2,129.2c-0.2-0.7-0.2-1.4,0-2.2c0.2-0.7,0.6-1.4,1.2-2c0.6-0.6,1.3-1,2-1.2s1.5-0.2,2.2,0
			c0.7,0.2,1.4,0.6,1.9,1.2c0.6,0.6,1,1.2,1.2,1.9c0.2,0.7,0.2,1.4,0,2.2c-0.2,0.7-0.6,1.4-1.2,2c-0.6,0.6-1.3,1-2,1.2
			c-0.7,0.2-1.5,0.2-2.2,0c-0.7-0.2-1.4-0.6-2-1.2C359.8,130.6,359.5,130,359.2,129.2z M362.7,130.4c0.4,0.1,0.8,0.1,1.2,0
			c0.4-0.1,0.8-0.4,1.2-0.8c0.6-0.6,0.8-1.1,0.9-1.7c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.2,0.3-1.7,0.9
			c-0.6,0.6-0.9,1.1-0.9,1.7c0,0.6,0.2,1.1,0.6,1.5C362,130.1,362.3,130.3,362.7,130.4z"
          />
          <path
            d="M378.7,139.8c-0.1,0.9-0.5,1.7-1.4,2.4l-3.7,3.2l-1.4-1.6l3.5-3c0.5-0.4,0.8-0.9,0.8-1.4
			c0-0.5-0.1-0.9-0.5-1.4c-0.4-0.4-0.8-0.7-1.3-0.7c-0.5,0-1,0.2-1.5,0.6l-3.5,3l-1.4-1.6l3.5-3c0.5-0.4,0.8-0.9,0.8-1.4
			c0-0.5-0.1-0.9-0.5-1.4c-0.4-0.4-0.8-0.7-1.3-0.7c-0.5,0-1,0.2-1.5,0.6l-3.5,3l-1.4-1.6l6.4-5.5l1.4,1.6l-0.8,0.7
			c0.4,0,0.9,0.1,1.3,0.3s0.8,0.5,1.2,0.9c0.4,0.5,0.7,1,0.8,1.6c0.1,0.6,0.1,1.1-0.1,1.7c0.5-0.1,1.1-0.1,1.7,0.1s1,0.5,1.4,1
			C378.4,138.1,378.7,138.9,378.7,139.8z"
          />
          <path
            d="M381.9,151l-3.6-4.9c-0.5,0.4-0.7,0.9-0.8,1.4c-0.1,0.5,0.1,1,0.4,1.4c0.5,0.6,1.1,0.9,1.8,0.8
			l1.4,1.8c-0.8,0.3-1.6,0.3-2.4,0.1c-0.8-0.2-1.5-0.8-2.1-1.6c-0.5-0.6-0.8-1.3-0.9-2.1c-0.1-0.7,0-1.4,0.3-2.1
			c0.3-0.7,0.8-1.3,1.5-1.8c0.7-0.5,1.4-0.8,2.2-0.9c0.7-0.1,1.4,0,2.1,0.3c0.7,0.3,1.2,0.8,1.7,1.5c0.5,0.6,0.8,1.3,0.9,2
			c0.1,0.7,0,1.4-0.3,2c-0.3,0.7-0.8,1.2-1.4,1.7C382.4,150.7,382.2,150.9,381.9,151z M381.8,148.4c0.4-0.3,0.7-0.7,0.7-1.3
			c0-0.5-0.1-1-0.4-1.4c-0.3-0.4-0.7-0.7-1.2-0.8s-1,0-1.5,0.3L381.8,148.4z"
          />
          <path
            d="M388.3,152.3c0.5,0.2,0.8,0.6,1.2,1l-1.8,1.2l-0.3-0.5c-0.4-0.6-0.8-0.9-1.2-1s-1,0.1-1.6,0.5
			L381,156l-1.2-1.8l7-4.7l1.2,1.8l-1.1,0.7C387.4,152,387.9,152.1,388.3,152.3z"
          />
          <path
            d="M393.1,159.5l-7.2,4.3l-1.1-1.8l7.2-4.3L393.1,159.5z M393.3,157.1c0.1-0.3,0.3-0.6,0.6-0.8
			c0.3-0.2,0.6-0.2,1-0.1s0.6,0.3,0.8,0.6c0.2,0.3,0.2,0.6,0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.2-1,0.1
			c-0.3-0.1-0.6-0.3-0.8-0.6C393.3,157.8,393.2,157.5,393.3,157.1z"
          />
          <path
            d="M396.9,168c-0.3,0.8-0.9,1.5-1.9,2.1l-4.3,2.3l-1-1.9l4.1-2.2c0.6-0.3,1-0.7,1.1-1.2
			s0.1-0.9-0.2-1.5c-0.3-0.5-0.7-0.8-1.1-1s-1,0-1.6,0.3l-4.1,2.2l-1-1.9l7.4-4l1,1.9l-0.9,0.5c0.5,0.1,0.9,0.3,1.3,0.5
			c0.4,0.3,0.7,0.7,1,1.1C397.1,166.3,397.2,167.2,396.9,168z"
          />
          <path
            d="M398.5,173.3l-3.7,1.8c-0.3,0.1-0.4,0.3-0.5,0.4c-0.1,0.2,0,0.4,0.1,0.7l0.4,0.9l-1.6,0.8l-0.6-1.2
			c-0.8-1.6-0.4-2.8,1.2-3.5l3.6-1.8l-0.4-0.9l1.6-0.8l0.4,0.9l1.9-0.9l0.9,1.9l-1.9,0.9l0.8,1.7l-1.6,0.8L398.5,173.3z"
          />
          <path
            d="M400.2,184.7l-2.4-5.6c-0.5,0.3-0.9,0.7-1.1,1.1s-0.1,1,0.1,1.5c0.3,0.7,0.8,1.1,1.6,1.1l0.9,2.1
			c-0.8,0.1-1.6-0.1-2.4-0.5c-0.7-0.4-1.3-1.1-1.7-2c-0.3-0.7-0.4-1.5-0.4-2.2s0.3-1.4,0.8-2c0.5-0.6,1.1-1,1.9-1.4
			c0.8-0.3,1.6-0.5,2.3-0.4s1.4,0.3,2,0.8c0.6,0.4,1,1,1.3,1.8c0.3,0.7,0.4,1.5,0.4,2.2c-0.1,0.7-0.3,1.4-0.8,1.9
			c-0.4,0.6-1,1-1.8,1.3C400.7,184.6,400.4,184.7,400.2,184.7z M400.6,182.2c0.5-0.2,0.8-0.6,1-1.1c0.2-0.5,0.1-1-0.1-1.5
			c-0.2-0.5-0.5-0.8-1-1c-0.4-0.2-0.9-0.2-1.5-0.1L400.6,182.2z"
          />
          <path
            d="M406.1,187.5c0.4,0.3,0.7,0.7,0.9,1.3l-2.1,0.8l-0.2-0.5c-0.2-0.6-0.6-1-1-1.2
			c-0.4-0.2-1-0.2-1.7,0.1l-3.9,1.5l-0.7-2l7.9-2.9l0.7,2l-1.2,0.5C405.2,187,405.7,187.2,406.1,187.5z"
          />
          <path
            d="M405.1,199.2l-1.9-5.8c-0.6,0.2-0.9,0.6-1.2,1c-0.2,0.5-0.2,1-0.1,1.5c0.2,0.7,0.7,1.2,1.5,1.3
			l0.7,2.2c-0.8,0-1.6-0.2-2.3-0.7c-0.7-0.5-1.2-1.2-1.5-2.2c-0.2-0.8-0.3-1.5-0.2-2.2c0.1-0.7,0.5-1.4,1-1.9c0.5-0.5,1.2-0.9,2-1.2
			c0.8-0.3,1.6-0.3,2.3-0.2c0.7,0.1,1.4,0.5,1.9,0.9c0.5,0.5,0.9,1.1,1.2,1.9c0.2,0.8,0.3,1.5,0.2,2.2c-0.1,0.7-0.4,1.3-0.9,1.8
			c-0.5,0.5-1.1,0.9-1.9,1.2C405.6,199.1,405.4,199.1,405.1,199.2z M405.8,196.7c0.5-0.2,0.9-0.5,1.1-1s0.2-1,0-1.5
			c-0.2-0.5-0.4-0.9-0.9-1.1c-0.4-0.2-0.9-0.3-1.5-0.2L405.8,196.7z"
          />
          <path
            d="M402.7,202.8c0.1-0.6,0.3-1.1,0.6-1.5c0.3-0.4,0.7-0.7,1.2-0.9l0.5,2.1c-0.3,0.1-0.5,0.3-0.7,0.7
			c-0.1,0.3-0.1,0.7,0,1.1c0.1,0.4,0.3,0.7,0.5,0.9c0.2,0.2,0.4,0.2,0.7,0.2c0.3-0.1,0.4-0.3,0.5-0.6c0.1-0.3,0.1-0.8,0.1-1.4
			c0-0.6,0-1.2,0.1-1.6c0.1-0.4,0.2-0.8,0.5-1.2c0.2-0.4,0.6-0.6,1.2-0.8c0.4-0.1,0.9-0.1,1.3,0.1c0.4,0.2,0.8,0.5,1.2,0.9
			c0.3,0.4,0.6,1,0.8,1.6c0.3,1,0.2,1.8-0.1,2.5s-0.9,1.2-1.7,1.5l-0.5-2c0.3-0.1,0.5-0.3,0.7-0.6c0.1-0.3,0.1-0.6,0-1
			c-0.1-0.4-0.2-0.6-0.4-0.8s-0.4-0.2-0.7-0.1c-0.3,0.1-0.4,0.3-0.5,0.6s-0.1,0.8-0.1,1.4c0,0.6,0,1.1-0.1,1.6
			c-0.1,0.4-0.2,0.8-0.5,1.2c-0.3,0.4-0.6,0.6-1.2,0.8c-0.5,0.1-0.9,0.1-1.4-0.1c-0.4-0.2-0.8-0.5-1.2-0.9c-0.3-0.4-0.6-1-0.8-1.6
			C402.6,204,402.6,203.4,402.7,202.8z"
          />
          <path
            d="M411.1,210.3l-4,0.9c-0.3,0.1-0.5,0.2-0.6,0.3c-0.1,0.2-0.1,0.4,0,0.7l0.2,1l-1.7,0.4l-0.3-1.3
			c-0.4-1.7,0.3-2.8,2-3.2l3.9-0.9l-0.2-1l1.7-0.4l0.2,1l2-0.4l0.5,2.1l-2,0.4l0.4,1.8l-1.7,0.4L411.1,210.3z"
          />
        </g>
      </g>
      <g id="circles">
        <path
          id="circle-outer"
          d="M245,489c-65.4,0-127-25.5-173.2-71.8S0,309.4,0,244c0-65.4,25.5-127,71.8-173.2S179.6-1,245-1
		c65.4,0,127,25.5,173.2,71.8S490,178.6,490,244c0,65.4-25.5,127-71.8,173.2S310.4,489,245,489z M245,1
		C180.1,1,119.1,26.3,73.2,72.2C27.3,118.1,2,179.1,2,244c0,64.9,25.3,125.9,71.2,171.8C119.1,461.7,180.1,487,245,487
		c64.9,0,125.9-25.3,171.8-71.2S488,308.9,488,244c0-64.9-25.3-125.9-71.2-171.8S309.9,1,245,1z"
        />
        <circle id="circle-inner" cx="245" cy="245" r="32" />
      </g>
    </svg>
  )
}
